
'use client'
import * as THREE from '../assets/js/engines/three/three.module';
import { CircuitRace, keysActions, PathFinder, Car, ai_cars_wax, sleep } from '../assets/js/cc.js';

import {Transformation3} from '../assets/js/engines/transform.js';

import {PhysicMain, profiles, frameTime} from '../lib/physic.js';
import { FontLoader } from '../assets/js/engines/three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from '../assets/js/engines/three/examples/jsm/geometries/TextGeometry.js';
import { ScreenBase } from './screen_base.ts';
import { getCar, getUserInfos } from '../lib/blockchainSession.ts';

    var lastAccel = null
    var accUp= false;
    var accDown= false;

    var accLeft= false;
    var accRight= false;
    const relative = true;
    let lastTT = 0; 
    var Ammo = null;
    let lastX1=null , lastX2=null;

    let vrSteer = false;
    let vrSteering = false;
    let vrAxis = new THREE.Vector3();
    const tmpEUL = new THREE.Euler();
    const tmpQ = new THREE.Quaternion();


    const tmpV31 = new THREE.Vector3();


    let steerAngle = 0;

    const tmpT = new Transformation3();
    const t = new Transformation3();

    var pressed = {};

    var lastFps;
    var lastPing;
    let nFrames = 0;
    var steerPos = null;
    var currentSteerValue = 0.0;

    const raycaster = new THREE.Raycaster();
    const pointer = new THREE.Vector2();

    export default class Play extends ScreenBase {

        steerSensibility;

        world;
        webSocket;
        globalLight;
        globalLight2;

        /*
        rpmController;
        damgageController;
        energyController;
        nitroController;
        */

        gameControls;
        currentTouches;
        skeleton;
       
        clockRender;

        intro;
        introCount;
        introCountLast;
        startCountInfos;
        loadingInfos;
        gameOverInfos;
        finishedInfos;
        speedFont;
        speedMat;
        infosFont;
        infosMat;
        curSegs;
        domH;
        
        gameStat;
        gameMessage;
        
        fa;

        UIItems;

        damageBar;

        sphereSun;
        sphereLight1;
        sphereLight2;
        
        isVr;

        phys;

        servMode;
        firstTime;
        thresold;
        gameData;
   
        
        constructor(engine, screenChanger, renderMode, DAmmo, glDomRef, DomEvents, blockchainSession, gameConfig, setactiveLinks, setuserinfos, setBCInfos, setgameStats, settotalBonus ){

            super(engine, screenChanger, renderMode, DAmmo, glDomRef, DomEvents, blockchainSession, gameConfig, setactiveLinks, setuserinfos, setBCInfos, setgameStats, settotalBonus);
               
            this.name = 'play';
            this.firstFrame = true;
             Ammo = DAmmo;
            

            this.gameData = null;
            this.steerSensibility = 0.5;
            this.inited = false;
    
            this.webSocket = null;
            this.globalLight = {};
            this.globalLight2 = {};
            this.phyActions = {};
            this.physicBuffer = null;
            
            if(window.Worker){
                this.isWorker = true;
                this.worker = new Worker("/assets/js/physicWorker.js");

                try{
                    this.physicBuffer = new SharedArrayBuffer(64*1024);
                }catch(e){
                    console.log('unable to create shared buffer '+e.message);
                    this.physicBuffer = null;
                }
 
            }else{
                this.fa = new Float32Array(64*1024);
                this.ia = new Int32Array(this.fa.buffer);
                this.isWorker = false;
            }
            /*
            this.rpmController = null;
            this.damgageController = null;
            this.energyController = null;
            this.nitroController = null;
            */

            this.gameControls = null;
            this.currentTouches = [];
            this.playerSelectFn = [];
            this.aiCars = [];
            this.playerCarIdx = [0,0,0,0];
            

            this.player = {nBufferSents : 0};
                
            this.clockRender = new THREE.Clock(true);
    
            this.thresold = 0.3;
            this.intro = 0;
            this.introCount = 3;
            this.introCountLast = 0;
            this.startCountInfos = null;
            this.loadingInfos = null;
            this.gameOverInfos = null;
            this.finishedInfos = null;
            this.speedFont = null;
            this.speedMat = null;
            this.infosFont = null;
            this.infosMat = null;
            this.curSegs = 0;
            this.domH = 0;
            this.hover = {};

            this.gameStat = 0;
            this.gameMessage = '';

            this.world = new CircuitRace(this.curEngine);
    
            
            this.UIItems = {};
    
            this.damageBar = [];
    
            this.sphereSun = {};
            this.sphereLight1 = {};
            this.sphereLight2 = {};
            
            this.isVr = false;
    
            this.phys = null;
    
            this.servMode = false;
            this.firstTime = true;
        }
        
        

        init() {

            const curEngine = this.curEngine;

            if(this.gameStat !== 1)
                return;

            if(this.intro !== 0)
                return;

            if(this.inited === true)
                return;

            this.inited = true;

            console.log('init '+this.gameStat+' '+this.intro);
            const self = this;

            function doInit(){

                if(self.gameStat !== 1)
                    return;

                if(self.intro !== 0)
                    return;

                console.log('do init '+this.gameStat+' '+this.intro);

                if(curEngine.AudioMusic){
                    curEngine.AudioMusic.removeEventListener('canplay', doInit);
                    curEngine.AudioMusic.play();
                }
                
                self.intro = 1;
                
                curEngine.clock = new THREE.Clock();
                self.world.startTime = curEngine.clock.getElapsedTime();

                curEngine.resetRain(self.world.track.roadObj, self.world.myCar.ChassisMesh.position);
                        
                self.player.nBufferSents = 0;

                console.log('start ');

                if(self.servMode)
                    self.webSocket.send('{"msg" : "startrace", "data":{}}');
                else{
                    
                    if(self.isWorker)
                        self.worker.postMessage({msg : 'start'});
                    else
                        self.phys.clock = new THREE.Clock();
                }
                self.removeLoadingTxt();
            }

            if(!curEngine.audioCtx){

                console.log('init audio');
                curEngine.initAudio().then(()=>
                {
                    curEngine.startSounds(this.world);
                    if(this.world.track.music.length>0) {
                        console.log('start music');
                        curEngine.playMusic("/assets/snd/"+this.world.track.music);
                        curEngine.AudioMusic.addEventListener('canplay', doInit);
                    }
                    else
                        doInit();
                });
            }else{
                if(this.world.track.music.length>0) {
                    console.log('start music');
                    curEngine.playMusic("/assets/snd/"+this.world.track.music);
                    curEngine.AudioMusic.addEventListener('canplay', doInit);
                }
                else
                    doInit();
            }
        }

        doAccel(acl) {

            const webSocket = this.webSocket;

            if ((this.intro < 2)||(this.gameStat !== 1))
                return true;

            if (lastAccel === null)
                lastAccel = { x: acl[0], y: acl[1], z: acl[2] };

            const delta = [acl[0] - lastAccel.x, acl[1] - lastAccel.y, acl[2] - lastAccel.z];
       
            if (delta[1] > 0.1) {
                if (!accUp) {
                    webSocket.send('{"msg" : "action", "data":{   "key" : "acceleration", "state": true }}');
                    accUp = true;
                }
            } else if (accUp) {
                webSocket.send('{"msg" : "action", "data":{   "key" : "acceleration", "state": false }}');
                accUp = false;
            }

            if (delta[1] < -0.1) {
                if (!accDown) {
                    webSocket.send('{"msg" : "action", "data":{   "key" : "braking", "state": true }}');
                    accDown = true;
                }
            } else {
                webSocket.send('{"msg" : "action", "data":{   "key" : "braking", "state": false }}');
                accDown = false;
            }

            if (delta[0] < -0.01) {
                if (!accLeft) {
                    webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": true }}');
                    accLeft = true;
                }
            } else if (accLeft) {
                webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": false }}');
                accLeft = false;
            }

            if (delta[0] > 0.01) {
                if (!accRight) {
                    webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": true }}');
                    accRight = true;
                }
            } else if (accRight) {
                webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": false }}');
                accRight = false;
            }
        }

        initSensorEvents() {

            this.curEngine.sensor.onreading = () => this.doAccel(this.curEngine.sensor.quaternion);
            this.curEngine.sensor.onerror = (event) => {
                if (event.error.name == 'NotReadableError') {
                    console.log("Sensor is not available.");
                }
            }
            this.curEngine.sensor.start();
        }

        resetCarActions(){

            for(let k in keysActions) {
               pressed[keysActions[k]] = false;
            }

            for(let car of this.world.cars){
                for(let k in car.actions) {
                    car.actions[k] = false;
                }
            }
        }

        keyup(e) {

            const curEngine = this.curEngine;
            const world = this.world;
            const webSocket = this.webSocket;
            
            /*
            if (this.gameStat !== 1)
                return true;
            */

            if (keysActions[e.code]) {

                if(keysActions[e.code] === 'light') {

                    if(world.myCar) {
                        world.myCar.lightState++;
                        if(world.myCar.lightState>2)
                            world.myCar.lightState = 0;
                    }

                }else if(keysActions[e.code] === 'camera') {

                    curEngine.camMode++;
                    if(curEngine.camMode>4)
                        curEngine.camMode=1;

                    if(curEngine.useMobileUI)
                        curEngine.updateCamIcon(this.gameControls);

                }/*else if(keysActions[e.code] === 'next-target') {
                    this.nextCarTargets(world.myCar);
                }else if(keysActions[e.code] === 'next-subsystem') {
                    this.nextCarTargetsSubSystem(world.myCar);
                }*/ else {

                    pressed[keysActions[e.code]] = false;

                    if(!this.servMode){
                        world.myCar.actions[keysActions[e.code]] = false;

                    }else if((webSocket !== null) && (webSocket.readyState == 1)) {
                        webSocket.send('{"msg" : "action", "data":{   "key" : "' + keysActions[e.code] + '", "state": false }}');
                    }
                }
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            return true;
        }


        keydown(e) {
            
            const world = this.world;
            if(!world)
                return;

            //await sleep(1);

            const curEngine = this.curEngine;
            const webSocket = this.webSocket;
            const now = new Date().getTime();
            
            if((!e.repeat)&&((now - this.endGameTime)>1000) && ((this.gameStat == 2)||(this.gameStat == 3))){

                if (!pressed[keysActions[e.code]]){

                    this.gameMessage = null;

                    if(this.gameOverInfos) {
                        curEngine.removeUIMesh(this.gameOverInfos.mesh);
                        this.gameOverInfos.mesh.meshGPU=null;
                    }
    
                    if(this.finishedInfos) {
                        curEngine.removeUIMesh(this.finishedInfos.mesh);
                        this.finishedInfos.mesh.meshGPU=null;
                    }
    
                    //this.wallet.UI.removeGameStats();
                    this.restartLevel();
                }
                return; 
            }
            
            if(e.key === 'l'){
                curEngine.camLight = curEngine.camLight ? false : true;
            }

            if(this.gameStat != 1)
                return;
            
            
            if (this.intro == 0){
                if (!pressed[keysActions[e.code]]){
                    this.init();
                    pressed[keysActions[e.code]] = true;
                }
                return;
            }


            if(e.code == 'KeyV')
            {
                if(this.curEngine.enableRagDollDBG === true)
                    this.removeRaDollCyls();
                else
                    this.createRaDollCyls();
            }

            if (keysActions[e.code]) {

     
                if((keysActions[e.code] !== 'light') && (keysActions[e.code] !== 'camera')){
                    if (!pressed[keysActions[e.code]]) {

                        world.myCar.actions[keysActions[e.code]] = 1.0;
                        
                        if ((webSocket !== null) && (webSocket.readyState == 1)) {
                            webSocket.send('{"msg" : "action", "data":{   "key" : "' + keysActions[e.code] + '", "state": "'+world.myCar.actions[keysActions[e.code]]+'"}}');
                        }

                        pressed[keysActions[e.code]] = true;
                    }
                }

                if (((this.gameStat == 2)||(this.gameStat == 3)) && (pressed["acceleration"])) {
                    this.restartLevel();
                }

            
                e.stopImmediatePropagation();

                if(e.returnValue)
                    e.returnValue = false;
                
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        }

        async loadInfoFont() {
            const loader = new FontLoader();

            this.speedFont = await loader.loadAsync('/assets/fonts/Impact_Regular.json');
            this.speedMat = new THREE.MeshBasicMaterial({ color: 0xffFFFF });

            this.speedFont = await loader.loadAsync('/assets/fonts/Impact_Regular.json');

            this.speedMat.depthWrite = false;
            this.speedMat.depthTest = false; 

        }

        
        updateTargetUI(car){

            const target_pos = {x  : 0 , y : 0.1, z: -4};
            const target_subsystem_pos = {x  : 0 , y : 0.0, z: -4};

            const d =  new THREE.Vector3();

            const mytarget = this.world.getCarTarget(car, car.selectedTargetId, car.selectedSubsystemId);

            //const targets = PhysicMain.prototype.getCarTargets(this.world.track, car.ChassisMesh.position, car.ChassisMesh.quaternion);
           
            if((car.selectedTargetId === this.currentSelectedTarget)&&(car.selectedSubsystemId === this.currentSelectedTargetSubSystem)){

                if(mytarget === null){

                    this.curEngine.targetMesh.visible = false;

                    if(this.currentTarget.name){
                        if(car.selectedTargetId === 0)
                            this.currentTarget.name.material.color.setRGB(0.8,0.8,0.8);
                        else
                            this.currentTarget.name.material.color.setRGB(0.8,0,0);
                    }

                    if(this.currentTarget.subsystemname){
                        if(car.selectedSubsystemId === 0)
                            this.currentTarget.subsystemname.material.color.setRGB(0.8,0.8,0.8);
                        else
                            this.currentTarget.subsystemname.material.color.setRGB(0.8,0,0);
                    }

                }else{
                    this.curEngine.targetMesh.visible = true;

                    
                    if(mytarget.subsystem === null)
                        this.curEngine.targetMesh.position.set(mytarget.pos.x, mytarget.pos.y, mytarget.pos.z);
                    else
                        this.curEngine.targetMesh.position.set(mytarget.subsystem.pos.x, mytarget.subsystem.pos.y, mytarget.subsystem.pos.z);
                    
                    this.curEngine.targetMesh.lookAt(this.curEngine.cameraAnchor.position);
                }

                if(this.currentTarget.name)
                    this.curEngine.updateCameraSpaceMesh(this.currentTarget.name, target_pos);

                if(this.currentTarget.subsystemname)
                    this.curEngine.updateCameraSpaceMesh(this.currentTarget.subsystemname, target_subsystem_pos);
                return;
            }

            if(car.selectedTargetId === 0){
                this.currentSelectedTarget = car.selectedTargetId;
                this.currentSelectedTargetSubSystem = car.selectedSubsystemId;
                return;
            }

            if(mytarget !== null){
                this.currentSelectedTarget = car.selectedTargetId;
                this.currentSelectedTargetSubSystem = car.selectedSubsystemId;            
            }
            return;

            if(this.currentTarget.name){
                this.curEngine.removeMesh(this.currentTarget.name);
                this.currentTarget.name = null;
            }
                
            if(this.currentTarget.subsystemname){
                this.curEngine.removeMesh(this.currentTarget.subsystemname);
                this.currentTarget.subsystemname = null;
            }

            if(car.selectedTargetId === 0){
                /*
                this.currentTarget.name = this.noTarget.clone();
                this.currentTarget.subsystemname = this.noTarget.clone();
                */

                if(this.currentTarget.name)
                    this.currentTarget.name.meshGPU = this.curEngine.addCameraSpaceMesh(this.currentTarget.name, target_pos);

                if(this.currentTarget.subsystemname)
                    this.currentTarget.subsystemname.meshGPU = this.curEngine.addCameraSpaceMesh(this.currentTarget.subsystemname, target_subsystem_pos);

                this.currentSelectedTarget = car.selectedTargetId;
                this.currentSelectedTargetSubSystem = car.selectedSubsystemId;
                return;
            }

            if(mytarget !== null){
                this.currentTarget.name = mytarget.txt.clone();
                this.currentTarget.name.meshGPU = this.curEngine.addCameraSpaceMesh(this.currentTarget.name, target_pos);
                this.currentSelectedTarget = car.selectedTargetId;
    
                if(mytarget.subsystem !== null){
                    this.currentTarget.subsystemname = mytarget.subsystem.txt.clone();
                }else{
                    this.currentTarget.subsystemname = this.noTarget.clone();
                }
    
                this.currentSelectedTargetSubSystem = car.selectedSubsystemId;            
                this.currentTarget.subsystemname.meshGPU = this.curEngine.addCameraSpaceMesh(this.currentTarget.subsystemname, target_subsystem_pos);
            }else{
                this.currentTarget.name = this.noTarget.clone();
                this.currentTarget.subsystemname = this.noTarget.clone();
    
                this.currentTarget.name.meshGPU = this.curEngine.addCameraSpaceMesh(this.currentTarget.name, target_pos);
                this.currentTarget.subsystemname.meshGPU = this.curEngine.addCameraSpaceMesh(this.currentTarget.subsystemname, target_subsystem_pos);
            }

        }

        createText(txt, font = this.speedFont, size = 8, height = 5) {


            
            const Txt = new TextGeometry(txt, {
                font: font,
                size: size,
                height: 5,
                curveSegments: 12,
                bevelEnabled: false,
                bevelThickness: 0,
                bevelSize: 0,
                bevelOffset: 0,
                bevelSegments: 0
            });


            Txt.computeBoundingBox();
            const mesh = new THREE.Mesh(Txt, this.speedMat);
            mesh.name = 'txt '+txt.substr(0,8);

            
            const sz = new THREE.Vector3(); 
            Txt.boundingBox.getSize(sz);

            Txt.translate(-sz.x / 2.0,  -sz.y / 2.0, 0);

            return { mesh: mesh, txt: Txt };
        }

        

        updateUI() {

            const curEngine = this.curEngine;
            const world = this.world;

            if (this.gameStat == 2) {

                if(!this.gameOverInfos) {
                    const gameover = this.createText(this.gameMessage, this.speedFont);
                    gameover.mesh.meshGPU = curEngine.addUIMesh(gameover.mesh);
                    curEngine.setUIPos(gameover.mesh, -gameover.txt.boundingBox.max.x / 2, 0);
                    this.gameOverInfos = gameover;
                }
            }else if (this.gameStat == 3) {

                if(!this.finishedInfos) {
                    const finished = this.createText("race finished !", this.speedFont);
                    finished.mesh.meshGPU = curEngine.addUIMesh(finished.mesh);
                    curEngine.setUIPos(finished.mesh, -finished.txt.boundingBox.max.x / 2, 0);
                    this.finishedInfos = finished;
                }
            }

            //curEngine.drawText(Math.abs(world.myCar.speed).toFixed(0).toString());
            
            if (this.gameStat === 0) {

                if (!this.loadingInfos) {
                    const loading = this.createText('loading ...', this.speedFont);
                    this.loadingInfos = loading;
                    this.loadingInfos.mesh.meshGPU = curEngine.addUIMesh(this.loadingInfos.mesh);
                    curEngine.setUIPos(this.loadingInfos.mesh, -loading.txt.boundingBox.max.x / 2, 0);
                }
            } else if (this.loadingInfos) {

                curEngine.removeUIMesh(this.loadingInfos.mesh);

                this.loadingInfos.txt.dispose();
                this.loadingInfos = null;
            }
            this.updateTargetUI(world.myCar);

                /*
                

                //if (world.myCar.carDef.id>=0)
                curEngine.updateDamage(this.damgageController, world.myCar.damage , world.myCar.maxdmg);
                curEngine.updateEnergy(this.energyController, world.myCar.power , world.myCar.carDef.battery ? world.myCar.carDef.battery.power : -1);

                if((world.myCar.nextNitro > 3000)&&(pressed['nitro']))
                    curEngine.updateNitro(this.nitroController, 1, (5000 - world.myCar.nextNitro) , 2000);
                else
                    curEngine.updateNitro(this.nitroController, 0, world.myCar.nextNitro , 5000);

                curEngine.updateRPM(this.rpmController, world.myCar.RPM, 8000);
                */
                /*
                curEngine.updateRaceUI( this.raceUI, 
                                        world.myCar.nBonus ? world.myCar.nBonus : 0,  
                                        world.myCar.multiplier ? world.myCar.multiplier : 1.0, 
                                        this.nitros, 
                                        Math.max(0,0, world.myCar.remainingTime.toFixed(1)), 
                                        world.myCar.nLaps ? world.myCar.nLaps : 0, 3, 
                                        world.myCar.RPM, 8000,
                                        nitroState , nitroVal, nitroMax,
                                        world.myCar.damage , world.myCar.maxdmg,
                                        world.myCar.power , world.myCar.carDef.battery ? world.myCar.carDef.battery.power : 0,
                                        world.myCar.speed
                                        );

                */  

            let nitroState;
            let nitroVal;
            let nitroMax;

            if((world.myCar.nextNitro > 3000)&&(pressed['nitro'])){
                nitroState = 1;
                nitroVal = (5000 - world.myCar.nextNitro);
                nitroMax = 2000;
            } else {
                nitroState = 0;
                nitroVal = world.myCar.nextNitro;
                nitroMax = 5000;
            }

            const mytarget = this.world.getCarTarget(world.myCar, world.myCar.selectedTargetId, world.myCar.selectedSubsystemId);
            const txt = mytarget ? mytarget.name : 'none';
            const stxt = mytarget && mytarget.subsystem ? mytarget.subsystem.name : 'none';

     
            curEngine.updateEnergyUI(this.energyUI, world.myCar.power, world.myCar.carDef.battery ? world.myCar.carDef.battery.power : 0, txt, stxt);
            curEngine.updateEngineUI(this.engineUI, world.myCar.RPM, world.myCar.speed, world.myCar.damage , world.myCar.maxdmg);
            curEngine.updateNitroUI(this.nitroUI, world.myCar.nitros ? world.myCar.nitros : 0, nitroState, nitroVal , nitroMax);
            curEngine.updateInfosUI(this.infosUI,  world.myCar.nBonus ? world.myCar.nBonus : 0, world.myCar.multiplier,  Math.max(0,0, world.myCar.remainingTime.toFixed(1)) , world.myCar.nTechs ? world.myCar.nTechs : 0);

            //this.setuserinfos({balance: this.userBalance, userInfos : {nitros : world.myCar.nitros, techBalance: this.userInfos ? this.userInfos.techBalance : 0}})
            

            if(curEngine.useMobileUI){
                curEngine.updateSprite(this.gameControls.cam);
                //curEngine.updateSprite(this.gameControls.wheel);
                curEngine.updateSprite(this.gameControls.accel);
                curEngine.updateSprite(this.gameControls.brake);
                curEngine.updateSprite(this.gameControls.nitro);
                curEngine.updateSprite(this.gameControls.left);
                curEngine.updateSprite(this.gameControls.right);

            }

            /*
            if (this.gameStat >= 1) {
            
                if (world.myCar.remainingTime < 0) {
                    $('#race-time').html('0');
                }
                else {
                    const rtxt = world.myCar.remainingTime.toFixed(1) + ' secs';
                    $('#race-time').html(rtxt);
                }


                const ltxt = parseInt(world.myCar.nLaps) + ' laps ' + (world.myCar.curSeg +1) + '/' + (world.track.trackPoints.length - 1);
                $('#race-laps').html(ltxt);
            }
            */

            /*
            //curEngine.updateSprite(cameraController.cam);

            curEngine.updateSprite(this.rpmController.rpm1);
            curEngine.updateSprite(this.rpmController.rpm2);

            curEngine.updateSprite(this.nitroController.nitro1);
            curEngine.updateSprite(this.nitroController.nitro2);
            curEngine.updateSprite(this.nitroController.nitro3);

            curEngine.updateSprite(curEngine.digits[0]);
            curEngine.updateSprite(curEngine.digits[1]);
            curEngine.updateSprite(curEngine.digits[2]);

            curEngine.updateSprite(this.damgageController.dmg1);
            curEngine.updateSprite(this.damgageController.dmg2);

            curEngine.updateSprite(this.energyController.energy1);
            curEngine.updateSprite(this.energyController.energy2);

            


            */
        }
        
        drawSegs(data) {
            if (data.segs.length !== this.curSegs) {

                for (let n = 0; n < data.segs.length; n++) {
                    const geometry = new THREE.BoxGeometry(data.segs[n].halfSize.x * 2, data.segs[n].halfSize.y * 2, data.segs[n].halfSize.z * 2);

                    const wireframe = new THREE.WireframeGeometry(geometry);

                    const line = new THREE.LineSegments(wireframe);
                    line.material.depthTest = true;
                    line.material.opacity = 1;
                    line.material.transparent = false;

                    line.position.set(data.segs[n].center.x, data.segs[n].center.y, data.segs[n].center.z);

                    this.curEngine.addMesh(line);
                }

                this.curSegs = data.segs.length;
            }
        }
    
        UIDraw(pipeline)
        {
            const curEngine = this.curEngine;

            /*
            if(this.rpmController){
                curEngine.drawSprite(this.rpmController.rpm1.spriteGPU, pipeline);
                curEngine.drawSprite(this.rpmController.rpm2.spriteGPU, pipeline);
            }

            if(this.nitroController){
                curEngine.drawSprite(this.nitroController.nitro1.spriteGPU, pipeline);
                curEngine.drawSprite(this.nitroController.nitro2.spriteGPU, pipeline);
                curEngine.drawSprite(this.nitroController.nitro3.spriteGPU, pipeline);
            }

            if(curEngine.digits.length>3){
                curEngine.drawSprite(curEngine.digits[0].spriteGPU, pipeline);
                curEngine.drawSprite(curEngine.digits[1].spriteGPU, pipeline);
                curEngine.drawSprite(curEngine.digits[2].spriteGPU, pipeline);
            }

            if(this.damgageController){
                curEngine.drawSprite(this.damgageController.dmg1.spriteGPU, pipeline);
                curEngine.drawSprite(this.damgageController.dmg2.spriteGPU, pipeline);
            }

            if(this.energyController){
                curEngine.drawSprite(this.energyController.energy1.spriteGPU, pipeline);
                curEngine.drawSprite(this.energyController.energy2.spriteGPU, pipeline);
            }
            */
            

            if(this.gameControls){
                curEngine.drawSprite(this.gameControls.cam.spriteGPU, pipeline);
                curEngine.drawSprite(this.gameControls.accel.spriteGPU, pipeline);
                curEngine.drawSprite(this.gameControls.brake.spriteGPU, pipeline);
                curEngine.drawSprite(this.gameControls.nitro.spriteGPU, pipeline);
                curEngine.drawSprite(this.gameControls.left.spriteGPU, pipeline);
                curEngine.drawSprite(this.gameControls.right.spriteGPU, pipeline);
            }

            if ((this.intro === 1) && (this.startCountInfos) && (this.startCountInfos.mesh.meshGPU))
                curEngine.drawMesh(this.startCountInfos.mesh.meshGPU, pipeline);

            if ((this.gameStat === 0) && (this.loadingInfos))
                curEngine.drawMesh(this.loadingInfos.mesh.meshGPU, pipeline);
            
            if ((this.gameStat == 2) && (this.gameOverInfos))
                curEngine.drawMesh(this.gameOverInfos.mesh.meshGPU, pipeline);

            if ((this.gameStat == 3) && (this.finishedInfos))
                curEngine.drawMesh(this.finishedInfos.mesh.meshGPU, pipeline);       
        }

        drawBone(bone, t, pipeline) {
                
            t.set(bone.obj.position, bone.obj.quaternion);
            this.curEngine.updateTransform(bone.obj, t);
            this.curEngine.drawMesh(bone.obj.meshGPU, pipeline);

            for(let child of bone.children) {
                this.drawBone(child, t, pipeline);
            }
        }

        mainDraw(pipeline)
        {
            const curEngine = this.curEngine;
            const world = this.world;

            if(this.gameStat >= 1){

                for(let n=0;n< world.track.npcs.length;n++) {
                    const npc = world.track.npcs[n];

                    if(npc.pathCurve){

                        /*
                        if(!npc.pathCurve.mesh){

                            const geo = new THREE.TubeGeometry(npc.pathCurve, 200, 0.25, 4, false);
                            npc.pathCurve.mesh = new THREE.Mesh(geo, new THREE.MeshBasicMaterial({color:0xFF0000}));
                            npc.pathCurve.mesh.meshGPU = curEngine.addMesh(npc.pathCurve.mesh);
                        }
                        curEngine.drawMesh(npc.pathCurve.mesh.meshGPU, pipeline);
                        */
                    }
                    
            
                    if((npc.avatarMesh)&&(npc.avatarMesh.meshGPU)) {

                        if(npc.instanceID == 0){

                            curEngine.drawMesh(npc.avatarMesh.meshGPU, pipeline);

                            for(let ss = 0;ss<npc.target.subsystems.length;ss++){
                                curEngine.drawMesh(npc.target.subsystems[ss].dmgBar.DMGBar1.meshGPU, pipeline);
                                curEngine.drawMesh(npc.target.subsystems[ss].dmgBar.DMGBar2.meshGPU, pipeline);
                            }
                        }
                    }

                    for(let i=0;i<npc.splitMesh.length;i++){

                        curEngine.drawMesh(npc.splitMesh[i].mesh.meshGPU, pipeline);

                    
                    }
                }

                curEngine.drawMesh(this.energyUI.mesh.meshGPU, pipeline);
                curEngine.drawMesh(this.engineUI.mesh.meshGPU, pipeline);
                curEngine.drawMesh(this.nitroUI.mesh.meshGPU, pipeline);
                //curEngine.drawMesh(this.infosUI.mesh.webGPU, pipeline);

    
                for(let w of world.track.terrain.waterFlows){
                    w.positionalAudio.updateMatrixWorld(true);
                    curEngine.drawMesh(w.object.meshGPU, pipeline);
                }
                
                for (let n = 0; n < world.track.turrets.length; n ++) {

                    curEngine.drawMesh(world.track.turrets[n].object.meshGPU, pipeline);

                    for (let i = 0; i < world.track.turrets[n].shots.length; i ++) {
                        curEngine.drawMesh(world.track.turrets[n].shots[i].meshGPU, pipeline);
                    }

                    curEngine.drawMesh(world.track.turrets[n].head.meshGPU, pipeline);
                }

               

                for (let n = 0; n < world.track.meshInstances.length; n ++) {
                    curEngine.drawMesh(world.track.meshInstances[n].meshGPU, pipeline);
                }

                for (let n = 0; n < world.track.drones.length; n ++) {

                    for (let i = 0; i < world.track.drones[n].shots.length; i ++) {
                        curEngine.drawMesh(world.track.drones[n].shots[i].meshGPU, pipeline);
                    }
                    
                    curEngine.drawMesh(world.track.drones[n].object.meshGPU, pipeline);

                    for (let i = 0; i < world.track.drones[n].pales.length; i ++) {

                        curEngine.drawMesh(world.track.drones[n].pales[i].mesh.meshGPU, pipeline);
                        curEngine.drawMesh(world.track.drones[n].pales[i].dmgBar.DMGBar1.meshGPU, pipeline);
                        curEngine.drawMesh(world.track.drones[n].pales[i].dmgBar.DMGBar2.meshGPU, pipeline);
                        
                    }
                }
                
                for (let n = 0; n < world.track.woods.length; n ++) {
                    for (let i = 0; i < world.track.woods[n].objects.length; i ++) {
                        curEngine.drawMesh(world.track.woods[n].objects[i].meshGPU, pipeline);
                    }
                }


                for (let n = 0; n < world.track.interestPoints.length; n ++) {
                    curEngine.drawMesh(world.track.interestPoints[n].lmesh.meshGPU, pipeline);
                }


                for (let n = 0; n < world.track.xmeshes.length; n ++) {
                    
                    if(!world.track.xmeshes[n])
                        continue;

                    /*
                    if(!world.track.xmeshes[n].phyMesh){

                        const geo = new THREE.BufferGeometry();
                        geo.setAttribute('position', new THREE.Float32BufferAttribute(this.phys.xmeshes[n].meshArray.subarray(0, this.phys.xmeshes[n].nVtx),3));
                        world.track.xmeshes[n].phyMesh = new THREE.Mesh(geo, new THREE.MeshBasicMaterial({color: 0xFFFFFF}));
                        world.track.xmeshes[n].phyMesh.meshGPU = curEngine.addMesh(world.track.xmeshes[n].phyMesh);
                    }
                      if((world.track.xmeshes[n].phyMesh)&&(world.track.xmeshes[n].phyMesh.meshGPU))
                        curEngine.drawMesh(world.track.xmeshes[n].phyMesh.meshGPU, pipeline);
                    */
                    
                    curEngine.drawMesh(world.track.xmeshes[n].mesh.meshGPU, pipeline);

                  
                }

                for (let n = 0; n < world.track.bonuses.length; n ++) {

                    if(!world.track.bonuses[n].taken)
                        curEngine.drawMesh(world.track.bonuses[n].object.meshGPU, pipeline);
                }

                for (let n = 0; n < world.track.terrain.cyls.length; n ++) {

                    if(world.track.terrain.cyls[n].isCyl)
                        curEngine.drawMesh(world.track.terrain.cyls[n].mesh.meshGPU, pipeline);
                    else
                        curEngine.drawMesh(world.track.terrain.cyls[n].meshGPU, pipeline);

                    if(world.track.terrain.cyls[n].l)
                        curEngine.drawMesh(world.track.terrain.cyls[n].l.meshGPU, pipeline);
                }

                for (let n = 0; n < world.track.terrain.cubes.length; n ++) {

                    if(world.track.terrain.cubes[n].isCube)
                        curEngine.drawMesh(world.track.terrain.cubes[n].mesh.meshGPU, pipeline);
                    else
                        curEngine.drawMesh(world.track.terrain.cubes[n].meshGPU, pipeline);
                }

                for (let n = 0; n < world.track.terrain.spheres.length; n ++) {
                    curEngine.drawMesh(world.track.terrain.spheres[n].meshGPU, pipeline);
                } 

                for (let n = 0; n < world.track.walls.length; n ++) {

                    if(world.track.walls[n].meshGPU)
                        curEngine.drawMesh(world.track.walls[n].meshGPU, pipeline);
                }

                for (let n = 0; n < world.track.springs.length; n ++) {
                    curEngine.drawMesh(world.track.springs[n].anchor.object.meshGPU, pipeline);
                    curEngine.drawMesh(world.track.springs[n].obj.object.meshGPU, pipeline);
                }

                const t = new Transformation3();

                for (let n = 0; n < world.track.spiders.length; n ++) {
                    this.drawBone(world.track.spiders[n].skel.root, t, pipeline);

                    for (let i = 0; i < world.track.spiders[n].shots.length; i ++) {
                        curEngine.drawMesh(world.track.spiders[n].shots[i].meshGPU, pipeline);
                    }
                }
                
                for (let n = 0; n < world.track.ropes.length; n ++) {
                    curEngine.drawMesh(world.track.ropes[n].anchor.object.meshGPU, pipeline);
                    curEngine.drawMesh(world.track.ropes[n].obj.object.meshGPU, pipeline);
                }
                for (let n = 0; n < world.track.terrain.movingTerrain.length; n ++) {
                    curEngine.drawMesh(world.track.terrain.movingTerrain[n].meshGPU, pipeline);
                }

                for (let n = 0; n < world.track.terrain.grasses.length; n ++) {
                    curEngine.drawMesh(world.track.terrain.grasses[n].mesh.meshGPU, pipeline);
                }

                for (let n = 0; n < world.track.terrain.blinks.length; n++) {
                    curEngine.drawMesh(world.track.terrain.blinks[n].obj.meshGPU, pipeline);
                }
            }

            if((this.board)&&(this.board.meshGPU)){
                curEngine.drawMesh(this.board.meshGPU, pipeline);
            }
            
            for(let char of world.characters) {
                if((char.avatarMesh)&&(char.avatarMesh.meshGPU)) {
                    curEngine.drawMesh(char.avatarMesh.meshGPU, pipeline);
                }
            }

            for(let car of world.cars) {

                if((car.ChassisMesh)&&(car.ChassisMesh.meshGPU)) {

                    curEngine.drawMesh(car.ChassisMesh.meshGPU, pipeline);
                    curEngine.drawMesh(car.nameMesh.meshGPU, pipeline);

                    for (let w of car.wheels) {
                        curEngine.drawMesh(w.mesh.meshGPU, pipeline);
                    }
                }

                for (let n = 0; n < car.nitroSpheres.length; n ++) {
                    curEngine.drawMesh(car.nitroSpheres[n].meshGPU, pipeline);

                    //console.log(car.nitroSpheres[n].meshGPU.primitives[0].material.emissive);
                }

                for (let n = 0; n < car.contacts.length; n ++) {

                    if(!car.contacts[n])
                        continue;

                    curEngine.drawMesh(car.contacts[n].meshGPU, pipeline);
                }

                for (let i = 0; i < car.shots.length; i ++) {
                    curEngine.drawMesh(car.shots[i].meshGPU, pipeline);
                }
            }

                
           for(let n=0;n<curEngine.particles.length;n++){
                curEngine.drawMesh(curEngine.particles[n].particleMesh, pipeline);
           }

           for(let n=0;n<curEngine.dropMarks.length;n++){
            curEngine.drawMesh(curEngine.dropMarks[n].mesh.meshGPU, pipeline);
           }

           if((curEngine.rainMesh)&&(curEngine.rainMesh.meshGPU))
                curEngine.drawMesh(curEngine.rainMesh.meshGPU, pipeline);


            if((world.track.terrain.base)&&(world.track.terrain.base.meshGPU))
                curEngine.drawMesh(world.track.terrain.base.meshGPU, pipeline);  

            if((world.track.terrain.mesh)&&(world.track.terrain.mesh.meshGPU))
                curEngine.drawMesh(world.track.terrain.mesh.meshGPU, pipeline);  

            if(pipeline !== 'shadow'){
                
                if(world.track.terrain.toon_mesh)
                    curEngine.drawMesh(world.track.terrain.toon_mesh.meshGPU);
                /*
                if(this.raceUI){
                    curEngine.drawMesh(this.raceUI.bonus.meshGPU, pipeline);

                    for(let c of this.raceUI.bonusTxt.chars){
                        curEngine.drawMesh(c.mesh.meshGPU, pipeline);
                    }
                    for(let c of this.raceUI.bonusM.chars){
                        curEngine.drawMesh(c.mesh.meshGPU, pipeline);
                    }

                    curEngine.drawMesh(this.raceUI.nitro.meshGPU, pipeline);
                    for(let c of this.raceUI.nitrosTxt.chars){
                        curEngine.drawMesh(c.mesh.meshGPU, pipeline);
                    }

                    curEngine.drawMesh(this.raceUI.timer.meshGPU, pipeline);
                    for(let c of this.raceUI.timerTxt.chars){
                        curEngine.drawMesh(c.mesh.meshGPU, pipeline);
                    }

                    curEngine.drawMesh(this.raceUI.lap.meshGPU, pipeline);
                    for(let c of this.raceUI.lapsTxt.chars){
                        curEngine.drawMesh(c.mesh.meshGPU, pipeline);
                    }

                    curEngine.drawMesh(this.raceUI.bonus.meshGPU, pipeline);
                    curEngine.drawMesh(this.raceUI.bonus.meshGPU, pipeline);
                    curEngine.drawMesh(this.raceUI.bonus.meshGPU, pipeline);

                    curEngine.drawMesh(this.raceUI.rpm2.meshGPU, pipeline);
                    curEngine.drawMesh(this.raceUI.rpm.meshGPU, pipeline);
                    

                    curEngine.drawMesh(this.raceUI.nitro1.meshGPU, pipeline);
                    curEngine.drawMesh(this.raceUI.nitro2.meshGPU, pipeline);
                    curEngine.drawMesh(this.raceUI.nitro3.meshGPU, pipeline);

                    curEngine.drawMesh(this.raceUI.dmg1.meshGPU, pipeline);
                    curEngine.drawMesh(this.raceUI.dmg2.meshGPU, pipeline);

                    curEngine.drawMesh(this.raceUI.nrj1.meshGPU, pipeline);
                    curEngine.drawMesh(this.raceUI.nrj2.meshGPU, pipeline);
                }
                */

                //curEngine.drawMesh(world.track.terrain.groundGPU, pipeline);

                
                curEngine.drawMesh(world.track.terrain.ground.meshGPU, pipeline);
                
                
                if(world.track.terrain.objs) {
                    const t = new Transformation3();
                    for(let o of world.track.terrain.objs){
                        t.set(o.position, o.quaternion);
                        curEngine.updateTransform(o, t);
                        curEngine.drawMesh(o.meshGPU, pipeline);
                    }
                }

                
                if((world.track.roadObj)&&(world.track.roadObj.meshGPU))
                    curEngine.drawMesh(world.track.roadObj.meshGPU, pipeline);

            }
        }

        endGame(){
            const world = this.world;

            if(!this.servMode){
               if(!this.isWorker){
                    const stats = this.phys.getStats(world.cars, world.startTime);
                    this.setgameStats(stats);
                    this.setLoadingTxt('press any key to restart');
                }else{
                    this.worker.postMessage({msg : 'getstats'});
                }
            }
        }


        doVrTurn(){
            const world = this.world;
            const curEngine = this.curEngine;

            if(vrSteer) {

                if(!vrSteering) {
                    vrAxis.set(curEngine.controller1.position.x, curEngine.controller1.position.y - 0.5, curEngine.controller1.position.z);
                    vrSteering = true;
                    steerAngle =  Math.atan2(0, 0.5);
                } else {
                    const delta = new THREE.Vector3().subVectors(curEngine.controller1.position, vrAxis);
                    const angle = Math.atan2(delta.x, delta.y);
                    const da = steerAngle - angle;

                    if(angle>0.1){
                        world.myCar.actions['left'] = 0.0;
                        world.myCar.actions['right'] = Math.min(Math.abs(angle * 8.0),1.0);
                    }else if(angle<-0.1){
                        world.myCar.actions['left'] = Math.min(Math.abs(angle * 8.0),1.0);
                        world.myCar.actions['right'] = 0.0;
                    }else{
                        world.myCar.actions['left'] = 0.0;
                        world.myCar.actions['right'] = 0.0;
                    }
                }
            }else if(vrSteering) {
                world.myCar.actions['left'] = 0.0;
                world.myCar.actions['right'] = 0.0;
                vrSteering = false;
            }
        }

        async updatePads(webSocket){

            const curEngine = this.curEngine;
            const world = this.world;
            const events = curEngine.updatePadsStatus();

            for (let ev of events) {

                const evpad = ev.xr ? curEngine.xrpadsState[ev.idx] : curEngine.pads[ev.idx];

                if ((this.gameStat == 1) && (this.intro == 0) && (evpad.pressed[ev.btn])) {
                    this.init();
                    break;
                }

                if (((this.gameStat == 2)||(this.gameStat == 3)) && (evpad.pressed[ev.btn])) {
                    await this.restartLevel();
                    break;
                }
                let gA;

                if(ev.axis !== undefined) {

                    if(ev.xr){

                        if(ev.axis == 2){
                            if(evpad.axes[ev.axis]<-0.1){
                                gA = 'axis0-';
                            }else if(evpad.axes[ev.axis]>0.1){
                                gA = 'axis0+';
                            }else{

                                if(curEngine.LeftAxis){
                                    if(this.servMode)
                                        webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": 0.0 }}');
                                    else
                                        world.myCar.actions['left'] = 0.0;

                                    curEngine.LeftAxis = false;
                                }

                                if(curEngine.RightAxis){
                                    if(this.servMode)
                                        webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": 0.0 }}');
                                    else
                                        world.myCar.actions['right'] = 0.0;

                                    curEngine.RightAxis = false;
                                }
                            }
                        }
                
                    }else{

                        if(evpad.axes[ev.axis]<-0.1){
                            gA = 'axis'+ev.axis+'-';
                        }else if(evpad.axes[ev.axis]>0.1){
                            gA = 'axis'+ev.axis+'+';
                        }else if(ev.axis === 0){

                            if(curEngine.LeftAxis){
                                if(this.servMode)
                                    webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": 0.0 }}');
                                else
                                    world.myCar.actions['left'] = 0.0;

                                curEngine.LeftAxis = false;
                            }

                            if(curEngine.RightAxis){
                                if(this.servMode)
                                    webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": 0.0 }}');
                                else
                                    world.myCar.actions['right'] = 0.0;

                                curEngine.RightAxis = false;
                            }
                        }
                    }

                    const a  = keysActions[gA];
                    if(!a){
                        continue;
                    }
                            
                    if(a == 'left') {
                        const s = -evpad.axes[ev.axis];

                        if(this.servMode)
                            webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": ' + s  + ' }}');
                        else
                            world.myCar.actions["left"] = s;

                            curEngine.LeftAxis = true;
                    }else if(curEngine.LeftAxis){

                            if(this.servMode)
                                webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": 0.0 }}');
                            else
                                world.myCar.actions["left"] = 0.0;

                            curEngine.LeftAxis = false;
                    }
                            
                    if(a == 'right') {
                            const s = evpad.axes[ev.axis];
                            if(this.servMode)
                                webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": ' + s + ' }}');
                            else
                                world.myCar.actions["right"] = s;

                            curEngine.RightAxis = true;
                    } else if(curEngine.RightAxis){

                            if(this.servMode)
                                webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": 0.0 }}');
                            else
                                world.myCar.actions["right"] = 0.0;

                            curEngine.RightAxis = false;
                    }
                }
                
                if(ev.btn !== undefined) {
                    const gK = curEngine.GAME_PAD_KEY_MAPPING[ev.btn] ? 'btn'+curEngine.GAME_PAD_KEY_MAPPING[ev.btn] : 'btn'+ev.btn;
                    const a  = keysActions[gK];
                    if( (a === 'camera') && (evpad.pressed[ev.btn])) {
                        curEngine.camMode++;
                        if(curEngine.camMode>4)
                            curEngine.camMode=1;   

                        if(curEngine.useMobileUI)
                            curEngine.updateCamIcon(this.gameControls);

                    }else if (a=='left') {
                        const l = evpad.pressed[ev.btn] ? 1.0 : 0.0;

                        if(this.servMode){
                            webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": 0.0 }}');
                            webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": ' + l + ' }}');
                        }else{
                            world.myCar.actions["right"] = 0.0;
                            world.myCar.actions["left"] = l;
                        }
                    }else if (a=='right') {
                        const r = evpad.pressed[ev.btn] ? 1.0 : 0.0;

                        if(this.servMode){
                            webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": 0.0 }}');
                            webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": ' + r +' }}');
                        }else{
                            world.myCar.actions["left"] = 0.0;
                            world.myCar.actions["right"] = r;
                        }
                    }else{

                        if(this.servMode)
                            webSocket.send('{"msg" : "action", "data":{   "key" : "'+a+'", "state": ' + evpad.pressed[ev.btn] + ' }}');
                        else
                            world.myCar.actions[a] =  evpad.pressed[ev.btn] ? 1.0 : 0.0;
                    }
                }
            }
            

            if(Math.abs(currentSteerValue) > 0.01){

                if(currentSteerValue < -0.1){

                    currentSteerValue += 0.01;

                    if(currentSteerValue>0)
                        currentSteerValue = 0;

                    if(this.servMode)
                        webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": ' + (-currentSteerValue)  + ' }}');
                    else if(world.myCar)
                        world.myCar.actions['left'] = -currentSteerValue;

                }else if(currentSteerValue > 0.1){

                    currentSteerValue -= 0.01;

                    if(currentSteerValue<0)
                        currentSteerValue = 0;

                    if(this.servMode)
                        webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": ' + currentSteerValue  + ' }}');
                    else if(world.myCar)
                        world.myCar.actions['right'] = currentSteerValue;
                }
            }
        }


        doAds(mesh, m , tt, n ){
             const curEngine = this.curEngine;

            const transtime = 1;
            const stoptime = 3;
            const totalCycle = transtime + stoptime;
            const nads = 4;
            const texStep = 1.0 / nads;

            const addsTimes = [stoptime, stoptime +totalCycle, stoptime +totalCycle*2, stoptime +totalCycle*3];

            const mtt = (tt + n) % (totalCycle * nads);
            if       ((mtt > addsTimes[0])&&(mtt < addsTimes[0] + transtime)){
                curEngine.setTextureOffset(mesh, m, (mtt -addsTimes[0])  *texStep / transtime + 0.75, 0.0);
            }else if ((mtt > addsTimes[1])&&(mtt < addsTimes[1] + transtime)){
                curEngine.setTextureOffset(mesh, m, (mtt -addsTimes[1])  * texStep / transtime + 0.50, 0.0);
            }else if ((mtt > addsTimes[2])&&(mtt < addsTimes[2] + transtime)){
                curEngine.setTextureOffset(mesh, m, (mtt -addsTimes[2])  * texStep / transtime + 0.25, 0.0);
            }else if ((mtt > addsTimes[3])&&(mtt < addsTimes[3] + transtime)){
                curEngine.setTextureOffset(mesh, m, (mtt -addsTimes[3])  *texStep / transtime + 0.00, 0.0);
            }
        }

        updateMovingMat(o, tt){
             const curEngine = this.curEngine;
             const nInst = o.nInstances > 0 ? o.nInstances : 1;

            const mq = new THREE.Quaternion();
            const eul = new THREE.Euler();

            for(let ii=0;ii<nInst;ii++){

                const spd = o.speeds ? o.speeds[ii] : 1.0;

                const iq = o.meshGPU ? o.meshGPU.transformations[ii].quaternion: o.quaternion;
                const p = o.meshGPU ? o.meshGPU.transformations[ii].position: o.position;

                const rot = o.rotation;

                //const rot = new THREE.Euler().setFromQuaternion(iq);

                if(o.material.length>0){
                    for(let mi = 0;mi<o.material.length;mi++){

                        const m = o.material[mi];

                        if(m.name.startsWith('wire-'))
                            curEngine.setTextureOffset(o, 'wire', 0.0, tt * spd);

                        if(m.name.startsWith('xwire-'))
                            curEngine.setTextureOffset(o, 'xwire', tt * spd, 0.0);

                        if(m.name.startsWith('ads')){
                            this.doAds(o, m.name, tt, mi);
                        }
            
                    }
                }else{

                    if(o.material.name.startsWith('wire-'))
                        curEngine.setTextureOffset(o, 'wire', 0.0, tt * 0.3);

                    if(o.material.name.startsWith('ads'))
                        curEngine.setTextureOffset(o, 'ads', 0.0, tt * 0.3);
                }
                
                if (o.name.startsWith('sign')) {
                    rot.y = spd * tt;
                }else if (o.name.startsWith('SWheelL')) {

                    tmpEUL.set(0, spd * tt, 0);
                    tmpQ.setFromEuler(tmpEUL);

                    o.quaternion.multiplyQuaternions(o.oQuaternion, tmpQ);

                }else if (o.name.startsWith('SWheelR')) {

                    eul.set(0, -spd * tt, 0);
                    mq.setFromEuler(eul);

                    o.quaternion.multiplyQuaternions(o.oQuaternion, mq);

                }else if (o.name.startsWith('SWheelT')) {

                    eul.set(0, 0, spd * tt);
                    mq.setFromEuler(eul);

                    o.quaternion.multiplyQuaternions(o.oQuaternion, mq);

                }else if (o.name.startsWith('SWheelF')) {

                    eul.set(spd * tt, 0, 0);
                    mq.setFromEuler(eul);

                    o.quaternion.multiplyQuaternions(o.oQuaternion, mq);

                }else if ((o.name.startsWith('buddha'))&&(this.world.myCar)) {
                    o.lookAt(this.world.myCar.ChassisMesh.position);
                }else if (o.name.startsWith('Crystal')) {
                    rot.y = spd * tt;
                }else if (o.name.startsWith('Star')) {
                    rot.z = spd * tt;
                }else if (o.name.startsWith('WheelL')) {

                    const ar = o.name.split('-');

                    if ((ar.length >=2)&&(ar[1].startsWith('cabin'))) 
                        rot.z = -spd * tt * 0.3;
                    else
                        rot.z = -spd * tt;

                }else if (o.name.startsWith('WheelR')) {
                    rot.z = -spd * tt;
                }else if (o.name.startsWith('WheelT')) {
                    rot.x = -spd * tt;
                }else if (o.name.startsWith('WheelA')) {
                    rot.x = +spd * tt;
                }else if (o.name.startsWith('WheelF')) {

                    const ar = o.name.split('-');

                    if ((ar.length >=2)&&(ar[1].startsWith('cabin'))) 
                        rot.y = -spd * tt * 0.3;
                    else
                        rot.y = -spd * tt;

                    

                    //console.log('wheelf '+o.name+' '+ii+' '+rot.y.toFixed(2)+' '+spd);

                }else if (o.name.startsWith('WheelB')) {

                    const ar = o.name.split('-');

                    if ((ar.length >=2)&&(ar[1].startsWith('cabin'))) 
                        rot.y = spd * tt * 0.3;
                    else
                        rot.y = spd * tt;

                } else if (o.name.startsWith('catarm')) {

                    if(!this.world.track.movingObjects.hasOwnProperty(o.name)){
                        const dir = o.name.substr(7);
                        if(dir =='z')
                            rot.z = Math.sin(0.8 * tt) * 0.25;
                        else if(dir =='y')
                            rot.y = Math.sin(0.8 * tt) * 0.25;
                        else if(dir =='x')
                            rot.x = Math.sin(0.8 * tt) * 0.25;
                    }
                }  else if (o.name.startsWith('Anchor')) {
                    const oname = o.name.substr(7);
                    
                    if(!this.world.track.movingObjects.hasOwnProperty(oname)){
                        const s = o.name.split('-');
                        const dir = s[2];
                        if(dir =='z')
                            rot.z = Math.sin(0.8 * tt) * 0.25;
                        else if(dir =='y')
                            rot.y = Math.sin(1.2 * tt) * 0.25;
                        else if(dir =='x')
                            rot.x = Math.sin(0.8 * tt) * 0.25;
                    }
                } 

                //q.setFromEuler(rot);
                tmpT.set(p, o.quaternion);
                curEngine.updateTransform(o, tmpT, ii)
            }
        }


        updateMovingObjects(tt, dt){

            const world = this.world;
            const curEngine = this.curEngine;

      
            const m = new THREE.Matrix4();
            const mr = new THREE.Matrix4();
            
            const vec3 = new THREE.Vector3();

            for (let n = 0; n < world.track.meshInstances.length; n ++) {

                if(world.track.meshInstances[n].meshGPU){
                    for(let mi=0;mi< world.track.meshInstances[n].meshGPU.primitives.length; mi++){
                        const m = world.track.meshInstances[n].meshGPU.primitives[mi].material;
                        if(m.name.startsWith('instance-')){
                            const arr = m.name.split('-');

                            if(arr[2].startsWith('texoffsetxy')){
                                const steps = parseFloat(arr[3]) / 10.0;
                                //curEngine.setTextureOffset(world.track.meshInstances[n], m.name, tt * 0.1, 0.0);
                                world.track.meshInstances[n].meshGPU.primitives[mi].material.instanceTextureOffset.x = steps;
                                world.track.meshInstances[n].meshGPU.primitives[mi].material.instanceTextureOffset.y = steps;
                                world.track.meshInstances[n].meshGPU.primitives[mi].needsUpdate = true;
                            }else if(arr[2].startsWith('texoffsetx')){
                                const steps = parseFloat(arr[3]) / 10.0;
                                curEngine.setTextureOffset(world.track.meshInstances[n], m.name, tt *steps, 0.0);
                                world.track.meshInstances[n].meshGPU.primitives[mi].material.instanceTextureOffset.x = steps;
                                world.track.meshInstances[n].meshGPU.primitives[mi].needsUpdate = true;
                            }else if(arr[2].startsWith('texangle')){
                                const steps = parseFloat(arr[3])/ 10.0;
                                world.track.meshInstances[n].meshGPU.primitives[mi].material.instanceTextureAngle = steps;
                                world.track.meshInstances[n].meshGPU.primitives[mi].needsUpdate = true;
                            }
                        }

                        if(m.name.startsWith('ads')){
                            this.doAds(world.track.meshInstances[n], m.name, tt, mi);
                        }
                    }
                }
            }
            for (let n = 0; n < world.track.springs.length; n ++) {

                if(world.track.springs[n].obj.object.meshGPU){
                    for(let mi=0;mi<world.track.springs[n].obj.object.meshGPU.primitives.length; mi++){
                        const m = world.track.springs[n].obj.object.meshGPU.primitives[mi].material;
                        if(m.name.startsWith('ads')){
                            this.doAds(world.track.springs[n].obj.object, m.name, tt, mi);
                        }
                    }
                }else{
                    for(let mi=0;mi<world.track.springs[n].obj.object.material.length; mi++){
                        const m = world.track.springs[n].obj.object.material[mi];
                        if(m.name.startsWith('ads')){
                            this.doAds(world.track.springs[n].obj.object, m.name, tt, mi);
                        }
                    }
                }
            }

            /*
            if(world.track.terrain.mesh){

                if(world.track.terrain.mesh.material.length>0){
                    for(let mi =0;mi<world.track.terrain.mesh.material.length;mi++ ){
                        const m =world.track.terrain.mesh.material[mi];

  

                        if(m.name.startsWith('wire-')){
                            curEngine.setTextureOffset(world.track.terrain.mesh, m.name, tt * 0.1, 0.0);
                        }
                        if(m.name.startsWith('ads')){
                            this.doAds(world.track.terrain.mesh, m.name, tt, mi);
                        }
                    }
                }else{
                    if((world.track.terrain.mesh.material.name.startsWith('wire-'))||(world.track.terrain.mesh.material.name.startsWith('ads'))){
                        curEngine.setTextureOffset(world.track.terrain.mesh, world.track.terrain.mesh.material.name, tt * 0.1, 0.0);
                    }
                }
            }
                */

            const cyls = world.track.terrain.cyls;
            for(let n = 0; n< cyls.length;n++){

                if(cyls[n].name.startsWith('col-barrel-fan')){

                    cyls[n].rotation.y = (tt + n / 4.0) * 0.6;
                    cyls[n].updateMatrix();

                    t.set(cyls[n].position, cyls[n].quaternion);
                    curEngine.updateTransform(cyls[n], t);

                }
            }

            const blinks = world.track.terrain.blinks;
            for(let n = 0; n< blinks.length;n++){

                const blinkPhase = parseInt((tt +n) * blinks[n].timeFac) % blinks[n].nMats;
                const blinkId = blinkPhase + 1;

                const mp = blinks[n].mats;
                const mpb = mp+'-'+ blinkId;
                const obj = blinks[n].obj;

                for(let m = 0; m < obj.material.length; m++) {

                    const mat = blinks[n].obj.material[m];
                    if(!mat.name.startsWith(mp))
                        continue;

                    if(mat.emissiveMap){
                        if(mat.name === mpb) {
                            curEngine.setEmission(obj, mat.name, 1.0, 1.0, 1.0, 4);
                        }else{
                            curEngine.setEmission(obj, mat.name, 0.5, 0.5, 0.5, 0.2);
                        }
                        
                    }else{
                        if(mat.name === mpb) {
                            curEngine.setEmission(obj, mat.name, mat.color.r, mat.color.g, mat.color.b, 4);
                        }else{
                            curEngine.setEmission(obj, mat.name, mat.color.r * 0.5, mat.color.g * 0.5, mat.color.b * 0.5, 0.2);
                        }

                    }
                    mat.needsUpdate = true;
                }
            }

            if(world.track.terrain) {


                for(let oid =0; oid< world.track.terrain.movingTerrain.length;oid++) {
                    this.updateMovingMat(world.track.terrain.movingTerrain[oid], tt);
                }

                for(let oid =0; oid< world.track.wires.length;oid++) {
                    this.updateMovingMat(world.track.wires[oid], tt);
                }
            }

            for(let fa in curEngine.fairies){

                const f = curEngine.fairies[fa];

                for(let fi = 0;fi < f.maxHearth; fi++){

                    mr.makeRotationY(dt);

                    f.hearth.getMatrixAt(fi, m);
                    m.elements[12] += Math.random() *0.5 - 0.5;
                    m.elements[13] -= dt * 3.0;
                    m.elements[14] += Math.random() *0.5 - 0.5;
                    m.multiply(mr);
                    f.hearth.setMatrixAt(fi, m);
                    t.fromMat4(m);
                    curEngine.updateTransform(f.rtObjs[fi], t);
                }

                if(f.lastTime>tt)
                    f.lastTime=tt;

                if((tt - f.lastTime)> 5 / f.maxHearth) {
                    
                    vec3.set(f.center.x + Math.random() *0.5 - 0.5, f.center.y+ Math.random() *0.5 - 0.5, f.center.z+ Math.random() *0.5 - 0.5).applyMatrix4(f.fairy.matrix);

                    m.identity();
                    m.makeTranslation(vec3);
                    f.hearth.setMatrixAt(f.cnt, m);

                    f.cnt++;

                    if(f.cnt >= f.maxHearth)
                        f.cnt = 0;

                    f.lastTime = tt;
                }
                f.hearth.instanceMatrix.needsUpdate = true;
            }

            
            for(let grass of world.track.terrain.grasses){

                if(world.track.trackPoints.length>1)
                    grass.doBillBoard( curEngine.cameraAnchor.quaternion);
                else if(grass.mesh){
                    grass.updateFolds(tt);
                }

                grass.mesh.instanceMatrix.needsUpdate = true;
            }
            

            for(let w of world.track.terrain.waterFlows){
                curEngine.setTextureOffset(w.object, 'waterflow', 0.0, -tt * 0.3);
            }
            
            if(world.triggerObject){
                world.triggerObject.obj.lookAt(curEngine.cameraAnchor.position);
            }
        }

        checkBoneSplit(char, bone) {

            if((bone.life === 0)&&(!bone.split)){
                const splitSkel = this.curEngine.splitBoneMesh(bone.name, char);
                bone.split = true;
            }

            for(let c of bone.children){
                this.checkBoneSplit(char, c);
            }
        }

        updateLoading(dt, tt){

            const curEngine = this.curEngine;
            const world = this.world;

            curEngine.enableRender(true, this.glDomRef);

            if((world.myCar)&&(world.myCar.ChassisMesh)){
                const loop = world.track.findLooping(world.myCar.ChassisMesh.position);
                const tube = world.track.getTube(world.myCar.curSeg);

                if(world.myCar.ChassisMesh)
                    curEngine.updateTransform(world.myCar.ChassisMesh, new Transformation3(world.myCar.ChassisMesh.position, world.myCar.ChassisMesh.quaternion));

                curEngine.updateCamera(world.myCar, loop, tube, world.track.terrain.mesh, dt, [world.track.ground]);
            }
            curEngine.loadingMesh.rotation.y = tt;

            if(this.board){

                const board = this.board;

                curEngine.updateCameraSpaceMesh(board, this.boardPos);

                curEngine.selectScene.position.set(board.position.x,board.position.y, board.position.z);
                curEngine.selectScene.scale.set(board.scale.x,board.scale.y, board.scale.z);
                curEngine.selectScene.quaternion.set(board.quaternion.x,board.quaternion.y, board.quaternion.z, board.quaternion.w);
                curEngine.selectScene.updateMatrix();
                curEngine.selectScene.updateMatrixWorld(true);
                curEngine.selectScene.updateWorldMatrix(true);
            }
                
            if(curEngine.rainMesh)
                curEngine.updateRain(tt, dt,  world.track.roadObj ? [world.track.roadObj] : [world.track.ground], world.myCar.ChassisMesh.position);
        }

        animate(dt, tt) {

            const curEngine = this.curEngine;
            const world = this.world;
            const webSocket = this.webSocket;

            if(this.curEngine.rtEngine){
                for(let n=0;n<world.cars.length;n++){
                    this.curEngine.rtEngine.findGeos(world.cars[n].ChassisMesh, 800);
                }
                this.curEngine.rtEngine.update(tt, dt, this.curEngine.cameraAnchor.position);
            }


            if(this.gameStat == 0) {
                this.updateLoading(dt, tt);
                return;
            }

            

            /*
            if(world.track.lastCurve2){

                if(this.tube){
                    this.curEngine.scene.remove(this.tube);
                    this.curEngine.scene.remove(this.tube2);
                }

                const m = this.curEngine.tubemat.clone();
                m.depthTest = false;
                m.transparent = true;

                const tubeGeometry1 = new THREE.TubeGeometry(world.track.lastCurve2, 20, 0.25, 4, false );
                this.tube = new THREE.Mesh(tubeGeometry1, m  );

                this.curEngine.scene.add(this.tube);

                const tubeGeometry2 = new THREE.TubeGeometry(world.track.curveC, 20, 0.25, 4, false );
                this.tube2 = new THREE.Mesh(tubeGeometry2, m  );

                this.curEngine.scene.add(this.tube2);
            }
            */

            if(curEngine.isVr) {
                this.doVrTurn()
            }

            if ((curEngine.pads.length > 0)||(curEngine.XRPads.length > 0)) {
                this.updatePads(webSocket);
            }
            
            //const dt = curEngine.clock.getDelta();
            //const tt = curEngine.clock.getElapsedTime();

            if((!this.servMode)&&(this.gameStat == 1)){

                if ((world.myCar.carDef.maxdmg>0)&&((world.myCar.damage) >= world.myCar.carDef.maxdmg)) {
                    this.gameStat = 2;
                    this.gameMessage = "damages too high !";
                    this.endGameTime = new Date().getTime();
                    curEngine.stopEngine();
                    this.endGame();
                } else if ((this.gameStat === 1)&&(world.myCar.curLapTime >= world.track.lapTime)&&(this.intro == 2)) {
                    this.gameStat = 2;
                    this.gameMessage = "time out !";
                    this.endGameTime = new Date().getTime();
                    curEngine.stopEngine();
                    this.endGame();
                }else if (world.myCar.nLaps>=3) {
                    this.gameStat = 3;
                    this.gameMessage = "race finished";
                    this.endGameTime = new Date().getTime();
                    curEngine.stopEngine();
                    this.endGame();
                } 
            }

            if((!this.servMode)&&(world.startTime>=0)){
                
                if(!this.isWorker){
                    this.phys.updatePhysicsUniverse(this.world, dt, tt);
                    this.phys.getCars(this.world.track, this.world.startTime, this.world.track.lapTime, this.player, tt, this.fa, this.ia);
                    const vec = new THREE.Vector3();

                    for(let i=0;i<this.phys.mbgrids.length;i++){

                        const grid = world.track.grids[i].MetaGrid;
                
                        const iquat = grid.grid_rot.clone().invert();
        
                        for(let n = 0; n < grid.nBalls; n++) {
                            vec.set(this.phys.mbgrids[i].balls[n].pos.x , this.phys.mbgrids[i].balls[n].pos.y, this.phys.mbgrids[i].balls[n].pos.z).sub(grid.grid_pos).applyQuaternion(iquat);
                            grid.vBalls[n * 4 + 0]= vec.x;
                            grid.vBalls[n * 4 + 1]= vec.y;
                            grid.vBalls[n * 4 + 2]= vec.z;
                        }
                        
                        //world.track.grids[i].fallBall.mesh.position.set(world.track.grids[i].fallBall.pos.x, world.track.grids[i].fallBall.pos.y, world.track.grids[i].fallBall.pos.z);
                        grid.Compute();
                        this.curEngine.updateMetaballGrid(world.track.grids[i]);
                    }
                }
                
                for(let i=0;i<this.world.track.npcs.length;i++){

                    if(this.world.track.npcs[i].skeleton)
                        this.checkBoneSplit(this.world.track.npcs[i], this.world.track.npcs[i].skeleton.root);

                }
            }
                
            
            if ((this.fa)&&(this.world.lastCarData != null)) {
                
                if(this.gameStat === 1)
                    this.world.bin2cars(this.fa, this.ia, tt);
                
                curEngine.updateCars(world, world.lastCarData.serverTime, world.lastCarData.serverFrame);

                for (let n = 0; n < world.lastCarData.cars.length; n++) {

                    if (world.lastCarData.cars[n].newAttachedObjects>0){
                        curEngine.playAudio('powerup', 1.0);
                    }
                }
            }


            this.updateMovingObjects(world.lastCarData.serverTime, world.lastCarData.serverFrame);

            if(world.myCar){
                world.myCar.ChassisMesh.updateWorldMatrix(true);
                curEngine.AudioListener.updateMatrixWorld(true);
            }

            const loop = world.track.findLooping(world.myCar.ChassisMesh.position);
            const tube = world.track.getTube(world.myCar.curSeg);
            const objs = world.track.trackPoints.length> 1 ? [world.track.roadObj] :  [world.track.ground];

            curEngine.updateCamera(world.myCar, loop, tube, world.track.terrain.mesh,  world.lastCarData.serverFrame, objs);

            if ((world.myCar) && (world.myCar.ChassisMesh)) {
                this.updateUI();
            }

            if (this.gameStat === 1) {

                for (let n = 0; n < world.track.drones.length; n ++) {

                    let s = 0;
                    while(s < world.track.drones[n].samples.length){

                        if(!world.track.drones[n].samples[s].isPlaying){
                            this.curEngine.scene.remove(world.track.drones[n].samples[s]);
                            world.track.drones[n].samples.splice(s, 1);
                        }else
                            s++;
                    }

                    if(curEngine.sfxGainNode){
                        for(let i=0;i<world.track.drones[n].newShots;i++){
                            const positionalAudio = new THREE.PositionalAudio( curEngine.AudioListener );
                            positionalAudio.setBuffer(world.track.drones[n].shotSndBuffer );
                            positionalAudio.setRefDistance( 2.0 );
                            positionalAudio.setRolloffFactor  (0.75);
                            positionalAudio.setMaxDistance ( 1000.0 );
                            positionalAudio.setDistanceModel('exponential');
                            positionalAudio.getOutput().connect(curEngine.sfxGainNode);
                            positionalAudio.position.set(world.track.drones[n].target.pos.x, world.track.drones[n].target.pos.y, world.track.drones[n].target.pos.z);
                             this.curEngine.scene.add(positionalAudio);

                            positionalAudio.play();
                            world.track.drones[n].samples.push(positionalAudio);
                        }
                    }

                    for(let i=0;i<world.track.drones[n].samples.length;i++){
                        world.track.drones[n].samples[i].updateMatrixWorld(true);
                    }
                }

                for (let n = 0; n < world.track.turrets.length; n ++) {

                    let s = 0;
                    while(s < world.track.turrets[n].samples.length){

                        if(!world.track.turrets[n].samples[s].isPlaying){
                            world.track.turrets[n].object.remove(world.track.turrets[n].samples[s]);
                            world.track.turrets[n].samples.splice(s, 1);
                        }else
                            s++;
                    }

                    if(curEngine.sfxGainNode){
                        for(let i=0;i<world.track.turrets[n].newShots;i++){
                            const positionalAudio = new THREE.PositionalAudio( curEngine.AudioListener );
                            positionalAudio.setBuffer(world.track.turrets[n].shotSndBuffer );
                            positionalAudio.setRefDistance( 2.0 );
                            positionalAudio.setRolloffFactor  (0.75);
                            positionalAudio.setMaxDistance ( 1000.0 );
                            positionalAudio.setDistanceModel('exponential');
                            positionalAudio.getOutput().connect(curEngine.sfxGainNode);
                            
                            world.track.turrets[n].object.add(positionalAudio);
                            positionalAudio.play();
                            world.track.turrets[n].samples.push(positionalAudio);
                        }
                    }

                    for(let i=0;i<world.track.turrets[n].samples.length;i++){
                        world.track.turrets[n].samples[i].updateMatrixWorld(true);
                    }
                }
                
                for (let n = 0; n < world.track.spiders.length; n ++) {
       
                    let s = 0;
                    while(s < world.track.spiders[n].samples.length){

                        if(!world.track.spiders[n].samples[s].isPlaying){
                            world.track.spiders[n].object.remove(world.track.spiders[n].samples[s]);
                            world.track.spiders[n].samples[s].getOutput().getOutput().disconnect();
                            world.track.spiders[n].samples.splice(s, 1);
                        }else
                            s++;
                    }

                    if(curEngine.sfxGainNode){

                        for(let i=0;i<world.track.spiders[n].newShots;i++){
                            const positionalAudio = new THREE.PositionalAudio( curEngine.AudioListener );
                            positionalAudio.setBuffer(world.track.spiders[n].sounds[4].sndBuffer );
                            positionalAudio.setRefDistance( 0.2 );
                            positionalAudio.setRolloffFactor  (0.75);
                            positionalAudio.setMaxDistance ( 1000.0 );
                            positionalAudio.setDistanceModel('exponential');
                            positionalAudio.getOutput().connect(curEngine.sfxGainNode);
                            
                            world.track.spiders[n].object.add(positionalAudio);
                            positionalAudio.play();
                            world.track.spiders[n].samples.push(positionalAudio);
                        }
                    }

                    for(let i=0;i<world.track.spiders[n].samples.length;i++){
                        world.track.spiders[n].samples[i].updateMatrixWorld(true);
                    }
                }
               
                for (let n = 0; n < world.track.drones.length; n ++) {
                    if(world.track.drones[n].positionalAudio){
                        world.track.drones[n].positionalAudio.updateMatrixWorld(true);
                    }
                }
            }

            if (this.intro === 1) {

                if(world.myCar.curLapTime<=0) {
                    this.introCount = (-parseInt(world.myCar.curLapTime)) + 1;
                } else {
                    this.intro = 2;

                    for(let n=0;n<world.cars.length;n++){
                        world.cars[n].active = true;
                        /*
                        if(!this.servMode)
                            this.phys.cars[n].active = true;
                        */
                    }

                    if (this.startCountInfos) {
                        curEngine.removeUIMesh(this.startCountInfos.mesh);
                        this.startCountInfos.txt.dispose();
                        this.startCountInfos = null;
                    }
                }

            }
            if (this.intro === 1) {
                if (this.introCount != this.introCountLast) {
                    const introCnt = this.createText(this.introCount.toString(), this.speedFont, 48);

                    if (this.startCountInfos) {
                        curEngine.removeUIMesh(this.startCountInfos.mesh);
                        this.startCountInfos.txt.dispose();
                    }

                    if(curEngine.AudioMusic && !curEngine.musicSync)
                    {
                        curEngine.AudioMusic.currentTime = 3-this.introCount;
                        curEngine.musicSync = true;
                    }

                    this.startCountInfos = introCnt;
                    this.startCountInfos.mesh.meshGPU = curEngine.addUIMesh(this.startCountInfos.mesh);
                    curEngine.setUIPos(this.startCountInfos.mesh, -introCnt.txt.boundingBox.max.x / 2, 0);
                    this.introCountLast = this.introCount;
                }
            }

            if(!isNaN(world.myCar.RPM)) {
                const pitch = curEngine.clamp(world.myCar.RPM / 80.0, 0.0, 107.0);
                curEngine.setPitch(pitch);
            }

            if(world.myCar) {

                if(world.myCar.targetNode >= 0){

                    if(world.myCar.pathMesh){
                        curEngine.removeMesh(world.myCar.pathMesh);
                        world.myCar.pathMesh.geometry.dispose();
                        world.myCar.pathMesh = null;
                    }                    
    
                    const fvec = new THREE.Vector3(0,0,1).applyQuaternion(world.myCar.ChassisMesh.quaternion);
                    const path = world.track.findPath(world.myCar.pathFinder, world.myCar.ChassisMesh.position, fvec, world.myCar.targetNode, 0x3);
    
                    if(path != null){
                        world.myCar.curvePts = [world.myCar.ChassisMesh.position.clone()]
        
                        for(let p of path){
                            world.myCar.curvePts.push(world.track.navmeshs[p].pos.clone());
                        }

                        if((world.myCar.targetNode & 0x00FF0000) != 0){
                        
                            const tagetType = (world.myCar.targetNode & 0x00FF0000) >> 16;
                            if(tagetType == 1){
                                const npcId = (world.myCar.targetNode & 0x0000FF00) >> 8;
                                const targetId = (world.myCar.targetNode & 0x000000FF);
                                const myss = world.track.findNPCTarget(npcId, targetId);
                                world.myCar.curvePts.push(new THREE.Vector3(myss.pos.x, myss.pos.y, myss.pos.z));
                            }
                        }

                        if(world.myCar.curvePts.length>=3){
                            const curve = new THREE.CatmullRomCurve3(world.myCar.curvePts, false);
                            const geo = new THREE.TubeGeometry(curve, 16, 0.6, 8, false);

                            const l = curve.getLength();

                            curEngine.pathMaterial.map.offset.x = -tt * 0.5;
                            curEngine.pathMaterial.map.repeat.set(l / 10.0, 2);
                            curEngine.pathMaterial.alphaMap.repeat.set( l / 10.0, 2);
                            curEngine.pathMaterial.alphaMap.offset.x = -tt * 0.5;
                
                            world.myCar.pathMesh = new THREE.Mesh(geo, curEngine.pathMaterial);
                            curEngine.addMesh(world.myCar.pathMesh);
                        }
                        
                    }
                }else if(world.myCar.pathMesh !== null){
                    curEngine.removeMesh(world.myCar.pathMesh);
                    world.myCar.pathMesh.geometry.dispose();
                    world.myCar.pathMesh= null;
                    world.myCar.curvePts = null;
                }
             

                if(world.track.trackPoints.length > 1){
                    let ratio = world.track.getCarDistance(world.myCar) - 0.02;
                    if(isNaN(ratio))
                        ratio = 0.0;

                    if(ratio > 1.0)
                        ratio -= 1.0;

                    if(ratio < 0.0)
                        ratio += 1.0;

                    ratio = Math.max(Math.min(ratio, 1.0),0.0);

                    const t = world.track.curveC.getUtoTmapping(ratio);
                        
                    const rat = ratio * world.track.NPoints;
                    const pt1 = Math.floor(rat);
                    const pt2 = Math.ceil(rat);
                    const frac = rat - pt1;

                    const r1 = pt1 / world.track.NPoints;
                    const r2 = pt2 / world.track.NPoints;

                    const normal1 = world.track.curveCFrames.binormals[pt1];
                    const normal2 = world.track.curveCFrames.binormals[pt2];
                        
                    //console.log(ratio);
                    //const pos = world.track.curveC.getPointAt(ratio);
                    //const normal = tmpV31.lerpVectors(normal1, normal2, frac).multiplyScalar(12.0);

                    //const lpos = pos.add(normal);
                    //lpos.y += 10.0;

                    const lpos = new THREE.Vector3(50, 400, 50);

                    curEngine.setShadowProj(250, 250, 1300);

                    curEngine.setShadowSource( lpos, world.myCar.ChassisMesh);
                    curEngine.setSunLight( lpos, world.myCar.ChassisMesh);
                    
                }else{

                    const lpos = tmpV31.set(-4.5, 400.0, -14);
                    this.curEngine.setShadowBias(0.001);
                    this.curEngine.setShadowProj(2250, 2250, 6000);
                    curEngine.setShadowSource( lpos);
                    //curEngine.setSunLight( lpos, world.myCar.ChassisMesh);
                    
                }
            }

            curEngine.lastTime = tt;

            if(curEngine.rainMesh){
                
                const dx = (world.lastCarData && world.lastCarData.cars.length >0) ? -world.lastCarData.cars[0].lerper.array[0 + 1] * world.myCar.speed * 0.1: 0;
                const dz = (world.lastCarData && world.lastCarData.cars.length >0) ? -world.lastCarData.cars[0].lerper.array[0 + 3] * world.myCar.speed * 0.1: 0;

                curEngine.updateRain(tt, dt,  world.track.roadObj ? [world.track.roadObj, world.track.roadWall, world.track.ground] : [world.track.ground], world.myCar.ChassisMesh.position, dx, dz);
            }

            if(world.track.trackPoints.length > 1){
                this.curEngine.updateCameraSpaceMesh(world.track.mapBoard, world.track.boardMapPos);
                this.curEngine.updateCameraSpaceMesh(world.track.miniMap, world.track.miniMapPos);

                const ctx = world.track.mapCanvas.getContext('2d');
                ctx.fillStyle = '#'+world.track.mapCanvasColor;
                ctx.fillRect(0, 0, world.track.mapCanvas.width, world.track.mapCanvas.height);

                const pids = new Array(world.cars.length);
                for(let n=0; n<world.cars.length;n++) {
                    const car = world.cars[n];
                    car.curveD = world.track.getCarDistance(car);
                    car.totalDist = car.nLaps + car.curveD;
                    pids[n] = {id : n , d: car.totalDist};
                }

                pids.sort(function (a, b){
                    if(a.d > b.d)
                        return -1;

                    if(a.d < b.d)
                        return 1;

                    return 0;
                });

                if(world.myCar){
                    ctx.fillStyle = '#FFFFFF';
                    ctx.fillText(world.myCar.nBonus, 8, 44 , 256);
                    ctx.fillText(Math.max(0,world.myCar.remainingTime).toFixed(2), 8, 130 , 256);

                    ctx.fillStyle = '#FF0000';
                    ctx.fillText(' x '+world.myCar.multiplier, 64, 44 , 256);
                }
                
    
                for(let n=0; n<4;n++) {

                    if(n>=world.cars.length){
                        ctx.fillText('---' , 8, 220 + n * 95, 256);
                        continue;
                    }

                    const pid = pids[n].id;
                    const car = world.cars[pid];

                    if(isNaN(car.curveD))
                        continue;

                    const p = world.track.mapCurve.getPointAt(Math.min(1.0,car.curveD));
                   
                    car.mapSphere.position.x = p.x;
                    car.mapSphere.position.y = p.y;
                    car.mapSphere.position.z = 0;
            
                    ctx.fillStyle = 'rgb('+car.color.r * 255+','+car.color.g * 255+','+car.color.b * 255+')';
                    ctx.strokeStyle = '#000000';
                    ctx.globalAlpha = 1.0;
                    ctx.font = "48px Arial";
                    ctx.textAlign = 'left';

                    if(car.nLaps >= 0){
                        const percent = parseInt(car.curveD *100);
                        const ptdx = pid + 1;
                        ctx.fillText('P' +ptdx + ' ' + car.nLaps.toString() +'/3 '+ percent +'%' , 8, 220 + n * 95, 256);
                    }
                }
                world.track.mapCanvasTex.needsUpdate = true;
            }
            else
                this.curEngine.updateMiniMap(this.world);

            
            /*
            if(!isVr){
                curEngine.render(dt);
                curEngine.postRender(world);
                //requestAnimationFrame(animate);
            }
            */
                
            return dt;
        }
        
        getXRTransform(camera){

            const offsetPosition = new THREE.Vector3(camera.position.x, camera.position.y, -camera.position.z) ;
            const offsetRotation = new THREE.Quaternion(camera.quaternion.x, camera.quaternion.y, -camera.quaternion.z, -camera.quaternion.w);

            offsetPosition.negate().applyQuaternion(offsetRotation.conjugate());

            return new XRRigidTransform({x : offsetPosition.x, y : offsetPosition.y, z : -offsetPosition.z}, 
                                        {x : offsetRotation.x, y : offsetRotation.y, z : -offsetRotation.z, w : -offsetRotation.w});
        }

        

        brender(){
            const self = this;
            const curEngine = this.curEngine;

            const dt = this.clockRender.getDelta();
            const tt = this.clockRender.getElapsedTime();

            curEngine.render(dt);
            nFrames++;
            this.animReq = requestAnimationFrame(function(){self.brender()});

        }
        
        plast = 0;

        async updatePhysics(){

            const dt = this.clockRender.getDelta();
            const tt = this.clockRender.elapsedTime;
            this.animate(dt, tt);

            if((tt-lastFps)>1){
                //$('#engine-fps').html( (nFrames / (tt-lastFps)).toFixed(0) );
                lastFps = tt;
                nFrames = 0;
            }

            /*
            const tt = this.clockRender.elapsedTime;
            const dt = this.plast > 0 ? this.clockRender.elapsedTime - this.plast :  frameTime / 1000.0;
            this.plast = this.clockRender.elapsedTime;
            
            this.phys.updatePhysicsUniverse(this.world, dt, tt);
            this.fa = this.phys.getCars(this.world.track, this.world.startTime, this.world.track.lapTime, this.player, tt);
            */

        }

        copyActions(actions){

            const deltaActions = {}

            for(let a in actions){
                if(actions[a] != this.phyActions[a]){
                    deltaActions[a] = actions[a];
                    this.phyActions[a] = actions[a];
                }
            }

            return deltaActions;
        }
        
        async srender(){

            const curEngine = this.curEngine;

            //const session = frame.session;
            //animationFrameRequestID = 1session.requestAnimationFrame(srender);

            if(this.gameStat == 0) {
                const dt = this.clockRender.getDelta();
                const tt = this.clockRender.getElapsedTime();
                this.updateLoading(dt, tt);

                if(this.world.myCar){
                    curEngine.CameraSpaceLight.position.copy(curEngine.cameraAnchor.position);
                    curEngine.CameraSpaceLight.target = this.world.myCar.ChassisMesh;
                }
                    
            }
            
            if(!curEngine.isVr){
                if(this.glDomRef.current)
                    curEngine.resizeCanvasToDisplaySize(this.glDomRef.current.offsetWidth, this.glDomRef.current.offsetHeight);
            }
            
            let dt = 0;

            if(!this.isWorker)
            {
                dt = this.clockRender.getDelta();
                const tt = this.clockRender.getElapsedTime();
                this.animate(dt, tt);
            }else{
                dt = this.plast > 0 ? this.clockRender.elapsedTime - this.plast :  frameTime / 1000.0;
                this.plast = this.clockRender.elapsedTime;
                dt = 0.016;
            }

            /*
            const tx = getXRTransform(curEngine.camera);
            curEngine.referenceSpace = curEngine.baseReferenceSpace.getOffsetReferenceSpace( tx );
            curEngine.renderer.xr.setReferenceSpace( curEngine.referenceSpace );

            curEngine.camera.matrixAutoUpdate = false;
            curEngine.camera.matrixWorldAutoUpdate = false;
            */
            
            /*
            const viewerPose = frame.getViewerPose(curEngine.referenceSpace);
            const glLayer = session.renderState.baseLayer;
            const gl = curEngine.renderer.getContext();
            gl.bindFramebuffer(gl.FRAMEBUFFER, glLayer.framebuffer);
            */

            /*
            curEngine.renderer.alpha = true;
            curEngine.renderer.preserveDrawingBuffer = true;
            curEngine.renderer.autoClearDepth = false;
            curEngine.renderer.autoClear = false;
            */
            /*
            if(viewerPose){
                for (const view of viewerPose.views) {
                    const viewport = glLayer.getViewport(view);
                    gl.viewport(viewport.x, viewport.y, viewport.width, viewport.height);
            */
            //curEngine.renderer.render(curEngine.scene, curEngine.camera);

            if(this.gameStat == 1) {
    
                if(this.world.myCar) {
                    const actions = this.copyActions(this.world.myCar.actions);
                    this.worker.postMessage({msg : 'actions', data: {actions: actions, newFrame:this.newFrame}});
                    this.newFrame = false;
                }
            }

            if((this.renderMode === 0)&&(this.firstFrame == true)) {
                curEngine.setAllCulled(curEngine.scene, true);
            }
                        
            curEngine.enableRender(true, this.glDomRef);
            curEngine.render(dt);


            if((this.renderMode === 0)&&(this.firstFrame == true)) {
                curEngine.setAllCulled(curEngine.scene, false);
            }

            this.firstFrame= false;
            
        }

        async runXR(xrSession) {
            const curEngine = this.curEngine;
            
            const worldRefSpace = await xrSession.requestReferenceSpace("local");
            if (worldRefSpace) {
                curEngine.baseReferenceSpace = worldRefSpace;
            }
        }

        async enableVR(on){
            const curEngine = this.curEngine;

            if(this.renderMode !== 0)
                return;

            if(on){
                curEngine.isVr = true;
                const session = curEngine.renderer.xr.getSession();
                curEngine.initXRControllers(session);
                await this.runXR(session);

                this.setupVRCarEvents();
            }else{
                curEngine.isVr = false;
                curEngine.camera.position.set(0,0,0);
                curEngine.camera.quaternion.set(0,0,0,1);

                /*
                animationFrameRequestID = xrSession.requestAnimationFrame(null);
                curEngine.renderer.setAnimationLoop(null);
                requestAnimationFrame(animate);
                */
            }
        }

        accelerate(on){

            const webSocket = this.webSocket;
            const world = this.world;


            if(on > 0){
                if (!pressed['acceleration']) {

                    world.myCar.actions["acceleration"] = 1.0;
                    if(this.servMode){
                        if ((webSocket !== null) && (webSocket.readyState == 1)) {
                            webSocket.send('{"msg" : "action", "data":{   "key" : "acceleration", "state": '+world.myCar.actions["acceleration"]+'}}');
                        }
                    }
                    pressed['acceleration'] = false;
                }
            } else if (pressed['acceleration']) {
                world.myCar.actions["acceleration"] = 0.0;
                if(this.servMode){
                    if ((webSocket !== null) && (webSocket.readyState == 1)) {
                        webSocket.send('{"msg" : "action", "data":{   "key" : "acceleration", "state": '+world.myCar.actions["acceleration"]+'}}');
                    }
                }
                pressed['acceleration'] = false;
            }
        }

        brake(on){
            const webSocket = this.webSocket;
            const world = this.world;
            
            if(on > 0){
                if (!pressed['braking']) {
                    world.myCar.actions["braking"] = 1.0;
                    if(this.servMode){
                        if ((webSocket !== null) && (webSocket.readyState == 1)) {
                            webSocket.send('{"msg" : "action", "data":{   "key" : "braking", "state": '+world.myCar.actions["braking"]+'}}');
                        }
                    }
                    pressed['braking'] = true;
                }
            } else if (pressed['braking']) {
                world.myCar.actions["braking"] = 0.0;
                if(this.servMode){
                    if ((webSocket !== null) && (webSocket.readyState == 1)) {
                        webSocket.send('{"msg" : "action", "data":{   "key" : "braking", "state": '+world.myCar.actions["braking"]+'}}');
                    }
                }
                pressed['braking'] = false;
            }
        }

        nitro(on){
            const webSocket = this.webSocket;
            const world = this.world;
            if(on === true){

                if (!pressed['nitro']) {
                    world.myCar.actions["nitro"] = true;
                    if(this.servMode){
                        if ((webSocket !== null) && (webSocket.readyState == 1)) {
                            webSocket.send('{"msg" : "action", "data":{   "key" : "nitro", "state": true }}');
                        }
                    }
                    pressed['nitro'] = true;
                }
            } else if (pressed['nitro']) {
                world.myCar.actions["nitro"] = false;
                if(this.servMode){
                    if ((webSocket !== null) && (webSocket.readyState == 1)) {
                        webSocket.send('{"msg" : "action", "data":{   "key" : "nitro", "state": false }}');
                    }
                }
                pressed['nitro'] = false;
            }
        }

        steerLeft(currentSteerValue){

            const curEngine = this.curEngine;
            const webSocket = this.webSocket;
            const world = this.world;

            if(this.servMode){
                webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": ' + currentSteerValue  + ' }}');
            }else{
                world.myCar.actions["left"] = currentSteerValue;
            }
            
            curEngine.leftSteer = true;

            if(curEngine.rightSteer){
                world.myCar.actions["right"] = 0;
                if(this.servMode){
                    if ((webSocket !== null) && (webSocket.readyState == 1)) {
                        webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": 0 }}');
                    }
                }
                curEngine.rightSteer=false;
            }
        }

        steerRight(currentSteerValue){

            const curEngine = this.curEngine;
            const webSocket = this.webSocket;
            const world = this.world;

            if(this.servMode){
                webSocket.send('{"msg" : "action", "data":{   "key" : "right", "state": ' + currentSteerValue  + ' }}');
            }else{
                world.myCar.actions["right"] = currentSteerValue;
            }

            curEngine.rightSteer = true;
            if(curEngine.leftSteer){
                world.myCar.actions["left"] = 0;
                if(this.servMode){
                    webSocket.send('{"msg" : "action", "data":{   "key" : "left", "state": 0 }}');
                }
                curEngine.leftSteer = false;
            }
        }
        
        charGoto(pos){

            if(this.servMode){
                this.webSocket.send('{"msg" : "action", "data":{   "key" : "goto", "state": 1, "pos" : { "x" : '+pos.x+' , "y": '+pos.y+', "z": '+pos.z+'} }}');
            }else{

            }
        }

        charUse(pos, t_obj){
            if(this.servMode){
                this.webSocket.send('{"msg" : "action", "data":{   "key" : "use", "state": 1, "pos" : { "x" : '+pos.x+' , "y": '+pos.y+', "z": '+pos.z+'}, "t_obj" : "'+t_obj+'" }}');
            }else{

            }
        }

        doHit(tch){

            const curEngine = this.curEngine;
            const self = this;

           
            if(tch.hit === 'accel')
                this.accelerate(1.0);

            if(tch.hit === 'left')
                this.steerLeft(1.0);                

            if(tch.hit === 'right')
                this.steerRight(1.0);                

            if(tch.hit === 'brake')
                this.brake(1.0);

            if(tch.hit === 'nitro')
                this.nitro(true);

            if(tch.hit === 'camera'){
                curEngine.camMode ++;
            
                if(curEngine.camMode > 4)
                    curEngine.camMode = 1;

                if(curEngine.useMobileUI)
                    curEngine.updateCamIcon();
            }
        }

        doUnHit(tch){
            
            if(tch.hit === 'left')
                this.steerLeft(0.0);

            if(tch.hit === 'right')
                this.steerRight(0.0);

            if(tch.hit === 'accel')
                this.accelerate(0.0);

            if(tch.hit === 'brake')
                this.brake(0.0);

            if(tch.hit === 'nitro')
                this.nitro(false);
        }

        async startGameTouch(e) {

            const curEngine = this.curEngine;

            if((this.gameStat == 2)||(this.gameStat == 3)){

                if (!pressed[keysActions[e.code]]){

                    this.gameMessage = null;

                    if(this.gameOverInfos) {
                        this.curEngine.removeUIMesh(this.gameOverInfos.mesh);
                        this.gameOverInfos.mesh.meshGPU=null;
                    }
    
                    if(this.finishedInfos) {
                        this.curEngine.removeUIMesh(this.finishedInfos.mesh);
                        this.finishedInfos.mesh.meshGPU=null;
                    }
    
                    //this.wallet.UI.removeGameStats();
                    await this.restartLevel();
                }
                return; 
            }

            if ((this.gameStat == 1) && (this.intro == 0)) {
                this.init();
                return;
            }

            if(!this.gameControls)
                return;
            
            const rect = e.target.getBoundingClientRect();
            let hasHit = false;

            for(let n=0;n<e.changedTouches.length;n++){

                const pointer = new THREE.Vector2();
              
                const width = this.glDomRef.current.offsetWidth;
                const height = this.glDomRef.current.offsetHeight;

                pointer.x =  ((e.changedTouches[n].clientX - rect.left) / width ) * 200 - 100;
                pointer.y = -((e.changedTouches[n].clientY - rect.top)  / height) * 200 + 100;
    
                const hit = curEngine.checkUIButtons(this.gameControls, pointer.x, pointer.y);
                if(!hit)
                    continue;

                const tch = { 
                    hit: hit.name,
                    id : e.changedTouches[n].identifier, 
                    pageX : e.changedTouches[n].pageX, 
                    pageY: e.changedTouches[n].pageY,
                    clientX : e.changedTouches[n].clientX, 
                    clientY: e.changedTouches[n].clientY
                };

                this.currentTouches.push(tch);

                this.doHit(tch);

                hasHit = true;
            }

            if(!hasHit)
                return;
            
            if (e.preventDefault) {
                e.preventDefault();
            } else {
                e.returnValue = false;
            }
            return false;
        }

        touchGameEnd(e){
            
            for(let n=0;n<e.changedTouches.length;n++){

                for(let i=0;i<this.currentTouches.length;i++){

                    if(this.currentTouches[i].id === e.changedTouches[n].identifier){
                        this.doUnHit(this.currentTouches[i]);
                        this.currentTouches.splice(i, 1);
                        break;
                    }
                }
            }
        }
        touchGameMove(e){

            if (e.preventDefault) {
                e.preventDefault();
            } else {
                e.returnValue = false;
            }
            return false;
        }

        

        gameClick2(e){

            const curEngine = this.curEngine;
            const world = this.world;
            
            const rect = e.target.getBoundingClientRect();
            const pointer = new THREE.Vector2();

            const width = this.glDomRef.current.offsetWidth;
            const height = this.glDomRef.current.offsetHeight;
                
            pointer.x =  ((e.clientX - rect.left) / width ) * 2.0 - 1.0;
            pointer.y = -((e.clientY - rect.top)  / height) * 2.0 + 1.0;

            curEngine.camera.updateWorldMatrix();

            raycaster.setFromCamera(pointer, curEngine.camera);

            /*
            let g;
            if(renderMode === 2){
                g = world.track.ground.clone();
                g.position.set(-world.track.terrain.offset.x, -world.track.terrain.offset.y, -world.track.terrain.offset.z);
            }
            else
                g = world.track.ground;
            */

            const intersectsPt = raycaster.intersectObjects([world.track.ground, world.myCar.ChassisMesh]);
            world.myCar.ChassisMesh.updateWorldMatrix();

            let dist = null;
            const pts = new THREE.Vector3();
            let type = null;
            let t_obj = null;
            for (let i = 0; i < intersectsPt.length; i++) {

                if ((dist === null) || (intersectsPt[i].distance < dist)) {
                    dist = intersectsPt[i].distance;
                    pts.set(intersectsPt[i].point.x, intersectsPt[i].point.y, intersectsPt[i].point.z);

                    if (intersectsPt[i].object.name.startsWith('Plane')) 
                        type = 'goto';
                    else if (intersectsPt[i].object.name.startsWith('Car')) {
                        t_obj = intersectsPt[i].object.name;
                        type = 'use';
                    }
                }
            }

            if(dist != null){
                if(type === 'goto')
                    this.charGoto(pts);
                else if(type === 'use')
                    this.charUse(pts, t_obj);
            }

        }

        gameClick(e) {

            if(!this.gameControls)
                return true;

            const curEngine = this.curEngine;
            const rect = e.target.getBoundingClientRect();
            const pointer = new THREE.Vector2();

            const width = this.glDomRef.current.offsetWidth;
            const height = this.glDomRef.current.offsetHeight;
                
            pointer.x =  ((e.clientX - rect.left) / width ) * 200 - 100;
            pointer.y = -((e.clientY - rect.top)  / height) * 200 + 100;

            const hit = curEngine.checkUIButtons(this.gameControls, pointer.x, pointer.y);
            if(!hit)
              return true;

            this.doHit({ hit : hit.name, pageX : e.pageX});

            if(e.preventDefault)
                e.preventDefault();
            else
                e.returnValue = false;
            
            return false;
        }

        gameClickUp(e) {

            if(!this.gameControls)
                return true;
            
            const curEngine = this.curEngine;
            
            const rect = e.target.getBoundingClientRect();
            const pointer = new THREE.Vector2();

            const width = this.glDomRef.current.offsetWidth;
            const height = this.glDomRef.current.offsetHeight;
                
            pointer.x =  ((e.clientX - rect.left) / width ) * 200 - 100;
            pointer.y = -((e.clientY - rect.top)  / height) * 200 + 100;

            const hit = curEngine.checkUIButtons(this.gameControls, pointer.x, pointer.y);

            this.accelerate(0.0);
            this.brake(0.0);
            this.nitro(false);
            this.steerLeft(0.0);
            this.steerRight(0.0);
        }

        
        setupVRCarEvents() {

            const curEngine = this.curEngine;
            const world = this.world;

            if(curEngine.controller1){

                this.selectStart1Func = function(e){ world.myCar.actions['nitros'] = true;}
                this.selectEnd1Func = function(e){ world.myCar.actions['nitros'] = false; }

                this.squeezeStart1Func =function(e){ vrSteer = true; vrSteering = false;};
                this.squeezeEnd1Func = function(e){ vrSteer = false;  }

                //this.inputsourceschange1Func = function(e){ $('#gl-dom').append('inputsourceschange 1 <br/>'); }

                curEngine.controller1.addEventListener( 'selectstart',  this.selectStart1Func);
                curEngine.controller1.addEventListener( 'selectend',  this.selectEnd1Func);

                curEngine.controller1.addEventListener( 'squeezestart', this.squeezeStart1Func );
                curEngine.controller1.addEventListener( 'squeezeend', this.squeezeEnd1Func);

                curEngine.controller1.addEventListener( 'inputsourceschange', this.inputsourceschange1Func );
            }

            if(curEngine.controller2){

                this.selectStart2Func = function(e){ world.myCar.actions['acceleration'] = true; }
                this.selectEnd2Func = function(e){ world.myCar.actions['acceleration'] = false; }

                this.squeezeStart2Func = function(e){ world.myCar.actions['braking'] = true; };
                this.squeezeEnd2Func = function(e){ world.myCar.actions['braking'] = false; };

                //this.inputsourceschange2Func = function(e){ $('#gl-dom').append('inputsourceschange 2 <br/>'); }

                curEngine.controller2.addEventListener( 'selectstart',  this.selectStart2Func);
                curEngine.controller2.addEventListener( 'selectend',  this.selectEnd2Func);

                curEngine.controller2.addEventListener( 'squeezestart', this.squeezeStart2Func );
                curEngine.controller2.addEventListener( 'squeezeend', this.squeezeEnd2Func);

                curEngine.controller2.addEventListener( 'inputsourceschange', this.inputsourceschange2Func );
            }
        }

        removeVRCarEvents() {

            const curEngine = this.curEngine;

            if(curEngine.controller1){

                curEngine.controller1.removeEventListener( 'selectstart',  this.selectStart1Func);
                curEngine.controller1.removeEventListener( 'selectend',  this.selectEnd1Func);

                curEngine.controller1.removeEventListener( 'squeezestart', this.squeezeStart1Func );
                curEngine.controller1.removeEventListener( 'squeezeend', this.squeezeEnd1Func);

                curEngine.controller1.removeEventListener( 'inputsourceschange', this.inputsourceschange1Func );
            }

            if(curEngine.controller2){

                curEngine.controller2.removeEventListener( 'selectstart',  this.selectStart2Func);
                curEngine.controller2.removeEventListener( 'selectend',  this.selectEnd2Func);

                curEngine.controller2.removeEventListener( 'squeezestart', this.squeezeStart2Func );
                curEngine.controller2.removeEventListener( 'squeezeend', this.squeezeEnd2Func);

                curEngine.controller2.removeEventListener( 'inputsourceschange', this.inputsourceschange2Func );
            }
        }

        setupCarEvents() {

            const self = this;

            this.gameClickFunc = function(e) { self.gameClick(e); }
            this.gameClickUpFunc = function(e) { self.gameClickUp(e); }

            this.startGameTouchFunc = function(e) { self.startGameTouch(e); }
            this.touchGameEndFunc = function(e) { self.touchGameEnd(e); }

            this.keydownFunc = function(e) { self.keydown(e); }
            this.keyupFunc = function(e) { self.keyup(e); }

              if(!this.eventObject)
                    return;

            this.eventObject.onMouseDown = function(e) {  self.gameClickFunc(e)};
            this.eventObject.onMouseUp = function(e) {  self.gameClickUpFunc(e)};
            
            this.eventObject.onTouchStart = function(e) {  self.startGameTouchFunc(e)};
            this.eventObject.onTouchEnd = function(e) {  self.touchGameEndFunc(e)};
            this.eventObject.onKeyDown = function(e) {  self.keydownFunc(e)};
            this.eventObject.onKeyUp = function(e) {  self.keyupFunc(e)};
        }
        
        removeCarEvents(){

            this.eventObject.onMouseDown = null;
            this.eventObject.onMouseUp = null;
            this.eventObject.onTouchStart = null;
            this.eventObject.onTouchEnd = null;
            this.eventObject.onKeyDown = null;
            this.eventObject.onKeyUp = null;
        }

        setupCharEvents(){
            const glDom = document.getElementById('gl-dom');
            const self = this;

            this.gameClick2Func = function(e) { self.gameClick2(e); };

            glDom.addEventListener('click' , this.gameClick2Func);
        }

        removeCharEvents(){
            const glDom = document.getElementById('gl-dom');
            glDom.removeEventListener('click' , this.gameClick2Func);
        }

        async restartLevel(){
            const curEngine = this.curEngine;
            const world = this.world;

            
            this.setactiveLinks({selectCar: true, garage: true, restart : false, lobby : false});
            this.setgameStats(null);
       
            this.intro = 0;
            this.gameStat = 0;
            this.inited = false;

            if(this.renderMode == 2){

                if(this.animReq) {
                    cancelAnimationFrame(this.animReq);    
                    this.animReq = null;
                }
            }
            
            if (this.startCountInfos) {
                curEngine.removeUIMesh(this.startCountInfos.mesh);
                this.startCountInfos.txt.dispose();
                this.startCountInfos = null;
            }

            if(this.gameOverInfos) {
                curEngine.removeUIMesh(this.gameOverInfos.mesh);
                this.gameOverInfos.txt.dispose();
                this.gameOverInfos=null;
            }

            if(this.finishedInfos) {
                curEngine.removeUIMesh(this.finishedInfos.mesh);
                this.finishedInfos.txt.dispose();
                this.finishedInfos= null;
            }

            if(this.loadingInfos){
                curEngine.removeUIMesh(this.loadingInfos.mesh);
                this.loadingInfos.txt.dispose();
                this.loadingInfos = null;
            }

            this.setLoadingTxt('press any key to start');

            if(!this.isWorker)
                this.fa = null;

            if(curEngine.isVr)
                this.removeVRCarEvents();

            this.removeCarEvents();
            this.removeCharEvents();
            this.resetCarActions();

            if(curEngine.AudioMusic !== null)
                curEngine.stopMusic();

            curEngine.resetRain(world.track.roadObj, world.myCar.ChassisMesh.position);
            const m = new THREE.Matrix4();

            for(let fa in curEngine.fairies){

                curEngine.fairies[fa].lastTime = 0;
                curEngine.fairies[fa].cnt = 0;

                m.identity();
                m.scale(0,0,0);
        
                for(let n=0;n<20;n++) {
                    curEngine.fairies[fa].hearth.setMatrixAt(n, m);
                }
            }

            curEngine.resetTrack(world.track);

            if(this.blockchaininfos.logType >= 0){
                this.userInfos = await getUserInfos(this.blockchaininfos);
                world.myCar.nitros = this.userInfos ? this.userInfos.nitros : 0;
            } else
                world.myCar.nitros = 5;

            for(let car of world.cars){
                car.skidPlanes = [];
                car.remainingTime = -300000;
                car.curLapTime = -300000;
                car.active = false;
                car.targetNode = -1;

                if(car.pathMesh) {
                    curEngine.removeMesh(car.pathMesh);
                    car.pathMesh.geometry.dispose();
                    car.pathMesh = null;
                }      

                let nitro = null;
                while((nitro =car.nitroSpheres.pop()) != null) {
                    this.curEngine.removeSphere(nitro);
                }
            }

            world.lastCarData = null;

            if(!this.servMode) {

                let numAI = 0;

                if( !this.isWorker){
                    this.phys.clearPhyTrack(world.track);
                    this.phys.createRoadPhy(world.track);
                    if(world.track.groundGeo){

                        if(world.track.trackPoints.length < 2)
                            this.phys.createGroundMesh(world.track, world.track.terrain.offset);
                    }
                    this.phys.addPhyTrack(world.track);
                    world.computeCarPos();

                    for(let n=0;n<world.cars.length;n++){
                        const car = world.cars[n];
                        const profile = car.isAI ? profiles[numAI++] : null;

                        if(world.track.carStartPos)
                            car.center.set(world.track.carStartPos.pos.x, world.track.carStartPos.pos.y, world.track.carStartPos.pos.z );

                        this.phys.addPhyCar(car, 0, 0, null, profile);
                    }

                    this.gameStat = 1;
                }else{

                    this.worker.postMessage({msg : 'clear', data: null});
                    const phycars = [];
                    world.computeCarPos();

                    for(let n=0;n<world.cars.length;n++){
                        const car = world.cars[n].toPhys();
                        car.profile = car.isAI ? profiles[numAI++] : null;

                        if(world.track.carStartPos){
                            car.center.x=world.track.carStartPos.pos.x;
                            car.center.y=world.track.carStartPos.pos.y;
                            car.center.z=world.track.carStartPos.pos.z;
                        }
                        phycars.push(car);
                    }

                    const phytrack = world.track.toPhys();
                    this.worker.postMessage({msg : 'addtrack', data: { track : phytrack, buffer: this.physicBuffer, cars : phycars}});
                }
      
                this.clockRender = new THREE.Clock(true);
                this.player.nBufferSents = 0;
                
            }else{

                if(this.webSocket !== null) {
                    if(this.webSocket.readyState == 1){

                        this.webSocket.close();
                        console.log('websocket closed');
                    }
                    this.webSocket = null;
                }
                this.initGame(this.gameData.serverPath, this.gameData.sessh, this.gameData.amhost, this.gameData.id);
            }

            this.setupCarEvents();

            if(curEngine.isVr)
                this.setupVRCarEvents();

             if(this.renderMode == 2){
                this.brender();
            }
    
            this.setactiveLinks({selectCar: true, garage: true, restart : true, lobby : true});
        }

        removeLoadingTxt(){
            if(this.loadingInfos){
                this.curEngine.removeUIMesh(this.loadingInfos.mesh);
                this.loadingInfos.mesh.material.dispose();
                this.loadingInfos.mesh.geometry.dispose();
                this.loadingInfos = null;
            }
        }

        setLoadingTxt(txt){

            this.removeLoadingTxt();

            const loadingTxt = this.createText(txt, this.speedFont, 12);

            loadingTxt.mesh.material = new THREE.MeshBasicMaterial({color: '#000'});

            loadingTxt.mesh.meshGPU = this.curEngine.addUIMesh(loadingTxt.mesh);
            this.curEngine.setUIPos(loadingTxt, 0, -40);
            this.curEngine.setMeshStatic(loadingTxt.mesh, false);
            this.loadingInfos = loadingTxt;

        }

        removeRaDollCyls(){

            this.curEngine.enableRagDollDBG = false;

            for(let c of this.world.track.npcs){
                if(!c.avatarDef.ragdoll)
                    continue;

                if(c.ragdollCyls){

                    let cyl;
                    while((cyl = c.ragdollCyls.pop())){
                        this.curEngine.removeMesh(cyl);
                    }
                }
            }
        }

        initEngine(){}
        initEngineWebGPU(){}
        createRaDollCyls(){

            this.curEngine.enableRagDollDBG = true;

            for(let c of this.world.track.npcs){
                if(!c.avatarDef.ragdoll)
                    continue;

                this.curEngine.createRagDollCyls(c);
            }
        }

        async load(){

            const curEngine = this.curEngine;
            const self = this;

            this.firstTime = true;
            this.intro = 0;
            this.gameStat = 0;

            this.setactiveLinks({selectCar: true, garage: true, restart : false, lobby : false});
            curEngine.renderMainScene = false;

            await this.loadInfoFont();

            this.loadingController = await this.curEngine.createLoading();
            this.curEngine.addLoadingController(this.loadingController);

            const res = await fetch(this.blockchaininfos.baseAddr+'/api/myGame' , {credentials : "include"});
            this.gameData = await res.json();

            if (this.gameData.error) {
                return false;
            }

            this.setLoadingTxt('load track');

            await curEngine.loadPlatform("plateforme");
            this.skeleton = await curEngine.loadSkeleton('avatar');
            
            await this.world.loadTrack(this.gameData.trackname, this.blockchaininfos.baseAddr);
            curEngine.createRoadMat(this.world.track);
            
            if(this.world.track.trackPoints.length > 1)
                curEngine.setBumpSize(1024 * 1, 1024 * 8, 64);
            else
                curEngine.setBumpSize(1024 * 8, 1024 * 8, 8);
           
            if(this.renderMode == 2){
                curEngine.addRenderPass('render' , function(pipeline){ self.mainDraw(pipeline) } );
                curEngine.addRenderPass('shadow' , function(pipeline){ self.mainDraw(pipeline) } );
                curEngine.addRenderPass('ui' , function(pipeline){ self.UIDraw(pipeline) } );
                this.animReq = requestAnimationFrame(function(){self.brender()});
            }
            else
                curEngine.renderer.setAnimationLoop(async function(e){ await self.srender() } );

            this.setLoadingTxt('init game info');

            const geo = new TextGeometry("none", { font: this.speedFont, size: 0.1, height: 0.1, curveSegments: 4 });
            geo.computeBoundingSphere();
            geo.translate(-geo.boundingSphere.radius, 0, 0);

            const mat = new THREE.MeshBasicMaterial({color: 0xAAAAAA});
            this.noTarget = new THREE.Mesh(geo, mat);

            this.setLoadingTxt('init 3D engine');

            if(curEngine.useMobileUI)
                this.gameControls = await curEngine.makeUIButtons();

            await curEngine.addSkyBox(this.world.track.skyBoxImg);

            const manager = new THREE.LoadingManager();
            manager.onProgress = function (url, itemsLoaded, itemsTotal) {
                self.loadingController.loading2.scale.x = itemsLoaded * 78 / itemsTotal;
            };

            this.setLoadingTxt('create track');
            await curEngine.createTrack(this.world.track, manager, this.loadingController);

            this.setLoadingTxt('initialize race');
            await curEngine.addTrack(this.world.track);

            const nBonus = this.world.track.getTotalBonus();
            this.settotalBonus(nBonus);

            this.energyUI = await this.curEngine.createEnergyUI();
            this.nitroUI = await this.curEngine.createNitroUI();
            this.infosUI = await this.curEngine.createInfosUI();
            this.engineUI = await  this.curEngine.createEngineUI();

            if(this.world.track.trackPoints.length > 1)
                await this.curEngine.createTrackMap(this.world.track);
            else
                this.curEngine.createMiniMap(this.world.track, 0);

            this.curEngine.removeLoading(this.loadingController);

            curEngine.renderMainScene = true;

            return true;
        }

        unload(){

            if(this.curEngine.rtEngine)
                this.curEngine.rtEngine.reset();

            
                
        }

        stop(){
            const curEngine = this.curEngine;
            const world = this.world;

            this.started = false;
            
            this.setgameStats(null);

            curEngine.removeLight(this.dir1)
            curEngine.removeLight(this.dir2)
                
            if(this.renderMode === 2){
                curEngine.addRenderPass('render' , null );
                curEngine.addRenderPass('shadow' , null );
                curEngine.addRenderPass('ui' , null );
                cancelAnimationFrame(this.animReq);
            }else
                curEngine.renderer.setAnimationLoop(null );

            if(this.animateTimer !== null){
                clearInterval(this.animateTimer);
                this.animateTimer=null;
            }

            curEngine.stopMusic();
            curEngine.stopEngine();
            curEngine.stopSounds(world);

            if(!this.servMode) {

                if(this.isWorker){
                    this.worker.postMessage({msg : 'clear', data: null});
                }else {
                    this.phys.clearPhyTrack(world.track);
                    this.phys.delete();
                }
            }else{

                if((this.webSocket !== null)&&(this.webSocket.readyState==1))
                    this.webSocket.close();
            }
            
            if(curEngine.isVr)
                this.removeVRCarEvents();

            this.removeCarEvents();
            this.removeCharEvents();

            if (this.startCountInfos) {
                curEngine.removeUIMesh(this.startCountInfos.mesh);
                this.startCountInfos.txt.dispose();
                this.startCountInfos = null;
            }

            if(this.gameOverInfos) {
                curEngine.removeUIMesh(this.gameOverInfos.mesh);
                this.gameOverInfos.txt.dispose();
                this.gameOverInfos=null;
            }

            if(this.finishedInfos) {
                curEngine.removeUIMesh(this.finishedInfos.mesh);
                this.finishedInfos.txt.dispose();
                this.finishedInfos= null;
            }

            if(this.loadingInfos){
                curEngine.removeUIMesh(this.loadingInfos.mesh);
                this.loadingInfos.txt.dispose();
                this.loadingInfos = null;
            }
            
            this.fa = null;
            this.ia = null;
            world.lastCarData = null;

            curEngine.removeTrack(world.track);
            curEngine.destroyTrack(world.track);
            curEngine.clearCachedCyls();

            for(let car of world.cars){
                
                curEngine.removeCar(car);
                curEngine.destroyObj(car.ChassisMesh);

                for(let w of car.wheels){
                    curEngine.destroyObj(w.mesh);
                }
            }

            this.curEngine.removeInfosUI(this.infosUI);
            this.curEngine.removeBoardUI(this.energyUI);
            this.curEngine.removeBoardUI(this.nitroUI);
            this.curEngine.removeBoardUI(this.engineUI);

            world.cars = [];
            world.myCar = null;

            /*
            curEngine.removeRpmController(this.rpmController);
            curEngine.removeNitroController(this.nitroController);
            curEngine.removeDamageController(this.damgageController);
            curEngine.removeEnergyController(this.energyController);
            */
            
            if(curEngine.useMobileUI)
                curEngine.removeUIButtons(this.gameControls);

            curEngine.removeRain();
            curEngine.removeAllParticles();

            this.gameStat = 0;

            if(this.renderMode === 2)
                curEngine.vertexAllocator.mergeRanges();

            if(this.renderMode === 1){
                curEngine.triangeBuffer.mergeRanges();
                curEngine.aabbBuffer.mergeRanges();
            }


            curEngine.resetTex();
                
            /*
            for(let r of curEngine.vertexAllocator.usedBufferRanges){
                if(r.flag === 10000){
                    console.log(r)
                }
            }
            curEngine.vertexAllocator.flag = 0;
            */
        }


        async startGame(){
            const self = this;
            const curEngine = this.curEngine;

            if(this.started)
                return;

            this.started = true;

            curEngine.resetRain(this.world.track.roadObj, this.world.myCar.ChassisMesh.position);

            if(this.board)
                curEngine.removeCameraSpaceMesh(this.board);

            curEngine.camMode = 2;

            if(this.world.track.trackPoints.length > 1)
                curEngine.addTrackMap(this.world);

            curEngine.enableTrackRT(this.world);
            curEngine.compileShaders();

            this.setLoadingTxt('get user infos');  
            
            if(this.blockchaininfos.logType >= 0){
                this.userInfos = await getUserInfos(this.blockchaininfos);
                this.world.myCar.nitros = this.userInfos ? this.userInfos.nitros : 0;
            } else
                this.world.myCar.nitros = 5;

            if(this.gameData.np == 1) {
                this.initGame(this.gameData.serverPath, this.gameData.sessh, this.gameData.amhost, -1);
            }else{
                this.initGame(this.gameData.serverPath, this.gameData.sessh, this.gameData.amhost, this.gameData.id);
            }

            this.setupCarEvents();

            window.restartLevel = function (){ self.restartLevel(); }
        }

        async enablePlayerSelectEvent(n, on = false){

            this.disabledPanelGroup('players', 'player'+n, on);

            if(on === false){
                if(this.gameData.racetype === 'practice'){
                    const b = this.findPanelButton('players', 'player'+n+'PvP');
                    b.disabled = true;
                    this.setButtonState(b, 2);

                    const bb = this.findPanelButton('players', 'player'+n+'PvP-cont');
                    bb.disabled = true;
                    this.setButtonState(bb, 2);

                }else{
                    const b = this.findPanelButton('players', 'player'+n+'PvP');
                    b.disabled = false;
                    this.setButtonState(b, 0);

                    const bb = this.findPanelButton('players', 'player'+n+'PvP-cont');
                    bb.disabled = false;
                    this.setButtonState(bb, 0);
                }
            }else{

                if(n>1)
                    this.selectPanelButton('players', 'player'+n+'None', 'player'+n);
            }

            
        }

        async loadAICars(){

            const netar = this.blockchaininfos.network.split('-');
            const cars =  netar[1] === 'testnet' ? ai_cars_wax.testnet : ai_cars_wax.mainnet;

            for(let n =0;n<cars.length;n++) {
                const dem  =cars[n];
                const carDef = await getCar(this.blockchaininfos, dem, 0, this.blockchaininfos.SA.collectionName);
                this.aiCars.push(carDef);
            }
        }

        async disablePlayerSelectEvent(n){

            const self = this;
            this.selectPanelButton('players', 'player'+n+'None', 'player'+n);
            this.disabledPanelGroup('players', 'player'+n, true);
        }

                
        getAiCars(){

            const aicars =  this.blockchaininfos.network.endsWith('testnet') ? ai_cars_wax.testnet : ai_cars_wax.mainnet;
            const aiiids = [];
            const world = this.world;

            for(let a=0; a < aicars.length; a++){

                let fnd = false;

                for(let c=0; c < world.cars.length; c++){

                    if(world.cars[c].carDef.id === aicars[a]){
                        fnd = true;
                        break;
                    }
                }

                if(!fnd)
                    aiiids.push(aicars[a]);
            }
            return aiiids;
        }

        async selectPlayer(ctrl, tmode){
            const world = this.world;
            const curEngine = this.curEngine;
            const self = this;

            var value = parseInt(ctrl.value);
            var text = ctrl.options[ctrl.selectedIndex].text;
            var ctrlIDX = parseInt(ctrl.id[1]);
            var nctrlIDX = ctrlIDX + 1;

            if(value === 0){

                for(let c =ctrlIDX-1;c<world.cars.length;c++ ){
                    curEngine.removeCar(world.cars[c]);
                }

                while(world.cars.length > ctrlIDX-1)
                    world.cars.pop();

                for(let c =nctrlIDX;c<=4;c++ ){
                    this.disablePlayerSelectEvent(c);
                }
            }

            if(value === 2){

                //$('#P'+ctrlIDX+'-select').prop('disabled', true);
                
                const aicars = this.getAiCars();

                const carid = aicars[ctrlIDX%2];

                const aiDef = await getCar(this.blockchaininfos, carid, 0, this.blockchaininfos.SA.collectionName);
                const aiCar = new Car(world.carId++, aiDef); 
                aiCar.isAI = true;
                await curEngine.addCar(aiCar, tmode, ctrlIDX - 1);

                world.cars.push(aiCar);

                world.computeCarPos();
                this.enablePlayerSelectEvent(nctrlIDX, false);
            }
        }

        setButtonState(b, state) {

            const panel = b.panel;
            const name = b.name;
            const curEngine = this.curEngine;

            if ((panel == 'players')) {

                if(b.group.startsWith('start')) {
                    switch (state) {
                        case 1:
                            if(b.name.endsWith('cont')){
                                curEngine.setColor(b.obj, b.name, 0.0, 1.0, 0.0);
                                curEngine.setEmission(b.obj, b.name, 0.0, 1.0, 0.0, 4.0);

                            }else{
                                curEngine.setColor(b.obj, b.name, 0.8, 1.0, 0.8);
                                curEngine.setEmission(b.obj, b.name, 0.8, 1.0, 0.8, 4.0);

                            }
                        break;
                        case 2:
                            if(b.name.endsWith('cont')){
                                curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            }else{

                            }
                        break;
                        default:
                            if(b.name.endsWith('cont')){
                                curEngine.setColor(b.obj, b.name, 0.1, 0.0, 0.0);
                                curEngine.setEmission(b.obj, b.name, 0.1, 0.0, 0.0, 4.0);
                            }else{
                                curEngine.setColor(b.obj, b.name, 0.8, 1.0, 0.8)
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            }
                        break;
                    }
                }

                if(b.group.startsWith('player')) {

                    const pid = parseInt(b.group.substr(6,1));
                    const arr = name.split('-');
                    if(arr[1] !== 'txt'){
            
                        switch (state) {
                            case 1:
                                if(b.name.endsWith('cont')){
                                    curEngine.setColor(b.obj, b.name, 0.0, 1.0, 0.0);
                                    curEngine.setEmission(b.obj, b.name, 0.0, 1.0, 0.0, 4.0);
    
                                }else{
                                    curEngine.setColor(b.obj, b.name, 0.8, 1.0, 0.8);
                                    curEngine.setEmission(b.obj, b.name, 0.8, 1.0, 0.8, 4.0);

                                }
                            break;
                            case 2:
                                if(b.name.endsWith('cont')){
                                    curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                                    curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                                }else{

                                }
                            break;
                            default:
                                if(b.name.endsWith('cont')){
                                    curEngine.setColor(b.obj, b.name, 0.1, 0.0, 0.0);
                                    curEngine.setEmission(b.obj, b.name, 0.1, 0.0, 0.0, 4.0);
                                }else{
                                    curEngine.setColor(b.obj, b.name, 0.8, 1.0, 0.8)
                                    curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                                }

                            break;
                        }
                    }
                }

                if ((b.group == 'racetype')) {

                    const arr = name.split('-');
                    const racetype = arr[1];
    
                    switch (state) {
                        case 1:
                            /*
                            if (this.racetypeTxt.hasOwnProperty(racetype)) {
                                curEngine.setColor(this.racetypeTxt[racetype].o, null, 0.2, 1.0, 0.0)
                                curEngine.setEmission(this.racetypeTxt[racetype].o, null, 0.2, 1.0, 0.0, 4.0);
                            }
                            */
    
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                                curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 0.2, 1.0, 0.0)
                                curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                            }
                            break;
                        case 2:
                            /*
                            if (this.racetypeTxt.hasOwnProperty(racetype)) {
                                curEngine.setColor(this.racetypeTxt[racetype].o, null, 1.0, 0.0, 0.0)
                                curEngine.setEmission(this.racetypeTxt[racetype].o, null, 1.0, 0.0, 0.0, 1.0);
                            }
                            */
    
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 1.0, 0.0, 0.0)
                                curEngine.setEmission(b.obj, b.name, 1.0, 0.0, 0.0, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 1.0, 0.0, 0.0)
                                curEngine.setEmission(bb.obj, bb.name, 1.0, 0.0, 0.0, 1.0);
                            }
                            break;
                        default:
                            /*
                            if (this.racetypeTxt.hasOwnProperty(racetype)) {
                                curEngine.setColor(this.racetypeTxt[racetype].o, null, 0.2, 1.0, 0.0)
                                curEngine.setEmission(this.racetypeTxt[racetype].o, null, 0.0, 0.0, 0.0, 1.0);
                            }
                            */
    
                            if (name.endsWith('-cont')) {
                                curEngine.setColor(b.obj, b.name, 0.2, 1.0, 0.0)
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setColor(bb.obj, bb.name, 1.0, 0.0, 0.0)
                                curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                            }
                            break;
                    }
                }
    
                if (b.group == 'weather')  {
    
                    const arr = name.split('-');
                    const env = arr[1];
    
                    switch (state) {
                        case 2:
                            /*
                            if (this.envTxt[env]) {
                                curEngine.setEmission(this.envTxt[env].o, this.envTxt[env].m.name, 0.0, 0.0, 0.0, 1.0);
                                curEngine.setColor(this.envTxt[env].o, this.envTxt[env].m.name, 0.0, 0.0, 0.0);
                            }
                            */
    
                            if (name.endsWith('-cont')) {
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                                curEngine.setColor(b.obj, b.name, 0.0, 0.0, 0.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                                curEngine.setColor(bb.obj, bb.name, 0.0, 0.0, 0.0);
                            }
                        break;
                        case 1:
                            /*
                            if (this.envTxt[env]){
                                curEngine.setEmission(this.envTxt[env].o, this.envTxt[env].m.name, 0.2, 1.0, 0.0, 4.0);
                                curEngine.setColor(this.envTxt[env].o, this.envTxt[env].m.name, 0.2, 1.0, 0.0);
                            }
                            */
                                
    
                            if (name.endsWith('-cont')) {
                                curEngine.setEmission(b.obj, b.name, 0.2, 1.0, 0.0, 4.0);
                                curEngine.setColor(b.obj, b.name,  0.2, 1.0, 0.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setEmission(bb.obj, bb.name, 0.2, 1.0, 0.0, 4.0);
                                curEngine.setColor(bb.obj, bb.name,  0.2, 1.0, 0.0);
                            }
                        break;
                        default:

                            /*
                            if (this.envTxt[env]) {
                                curEngine.setEmission(this.envTxt[env].o, this.envTxt[env].m.name, 0.0, 0.0, 0.0, 1.0);
                                curEngine.setColor(this.envTxt[env].o, this.envTxt[env].m.name, 1.0, 1.0, 1.0);
                            }
                            */
    
                            if (name.endsWith('-cont')) {
                                curEngine.setEmission(b.obj, b.name, 0.0, 0.0, 0.0, 1.0);
                                curEngine.setColor(b.obj, b.name, 1.0, 0.0, 0.0);
                            } else {
                                const bb = this.findPanelButton(panel, name + '-cont');
                                curEngine.setEmission(bb.obj, bb.name, 0.0, 0.0, 0.0, 1.0);
                                curEngine.setColor(bb.obj, bb.name, 1.0, 0.0, 0.0);
                            }
                        break;
                    }
                }
            }

           
        }

        
        findPanelButton(panel, name) {
    
            for (var b of this.buttons) {

                if ((panel === b.panel) && (b.name == name))
                    return b;
            }

            return null;

        }

        disabledPanelGroup(panel, group, on) {

            for (var b of this.buttons) {

                if ((panel === b.panel) && (group === b.group)) {
                    b.disabled = on;
                    this.setButtonState(b, b.selected === true ? 1 : b.disabled === true ? 2 : 0);
                }
            }
        }

        processPointer(intersectsPt, hover) {

                        
            for (let b of this.buttons) {

                if (!b.name.endsWith('-cont'))
                    this.setButtonState(b, b.selected ? 1 :b.disabled === true ? 2 : 0);
            }

            hover.HoverButton = null;

            let minDist = null;
            let selObject = null;

            for (let i = 0; i < intersectsPt.length; i++) {

                if(intersectsPt[i].distance > 10)
                    continue;


                if((minDist === null)||(minDist < intersectsPt[i].distance)){

                    const oname = intersectsPt[i].object.name;
                    let unsel = false;
                    let disabled = false;

                    if (oname.startsWith('panel-')) {
                        const ar = oname.split('-');
                        const panel = ar[1];
                        const name = intersectsPt[i].object.material.name;

                        for (let b of this.buttons) {

                            if ((b.panel === panel) && (b.name === name)&&(b.disabled === true)){
                                disabled = true;
                            }

                            if ((b.panel === panel) && (b.name === name)&&(b.unselable === true)){
                                unsel=true;
                                break;
                            }
                        }
                    }
                        
                    if((!unsel)&&(!disabled)){
                        selObject = intersectsPt[i];
                        minDist = intersectsPt[i].distance;
                    }
                }
            }

            if(selObject){

                const oname = selObject.object.name;


                if (oname.startsWith('panel-')) {
                    const ar = oname.split('-');
                    const panel = ar[1];
                    const name = selObject.object.material.name;
    
                    for (let b of this.buttons) {
    
                        if(b.unselable === true)
                            continue;
    
                        if ((b.panel === panel) && (b.name === name)) {
    
                            this.setButtonState(b, 1);
                            hover.HoverButton = b;
                        }
                    }
                }
            }
        }

        
        selectPanelButton(panel, name, group = null) {

            const world = this.world;
            const curEngine =this.curEngine;
    
            let dg = null;

            for (var b of this.buttons) {

                if ((panel === b.panel) && ((group == null) || (group === b.group))) {

                    const cname = b.name.endsWith('-cont') ? b.name.substr(0, b.name.length - 5) : b.name;
                    const selected = (cname == name) ? true : false;

                    if (b.selected || selected) {
                        
                        if(panel === 'players'){

                            const playid = parseInt(group.substr(6 , 1));
                            const which = b.name.substr(7);
                            const tmode = this.renderMode === 0 ? this.servMode ===true ? 2 : 0 : this.renderMode === 1 ? 1 : 0;

                            if (name.endsWith('prev')) {

                                const aicars = this.getAiCars();

                                if(aicars.length>0) {
                                    
                                    if(world.cars[playid - 1]){
                                        curEngine.removeCar(world.cars[playid - 1]);
                                    }

                                    this.playerCarIdx[playid-1]--;

                                    if(this.playerCarIdx[playid-1] < 0){
                                        this.playerCarIdx[playid-1] = aicars.length;
                                    }

                                    this.disabledPanelGroup('players', 'player'+playid, true);
        
                                    const id = parseInt(aicars[this.playerCarIdx[playid-1]]);
                                    getCar(this.blockchaininfos, id, 0, this.blockchaininfos.SA.collectionName).then((aiDef)=>{
                                        const aiCar = new Car(world.carId++, aiDef); 
                                        aiCar.isAI = true;
                                        curEngine.addCar(aiCar, tmode, playid - 1).then(()=>{
                                            world.cars[playid - 1] = aiCar;
                                            world.computeCarPos();
                                            this.updatePlayersText();
                                            this.disabledPanelGroup('players', 'player'+playid, false);
                                        })
                                    })
                                }

                                

                                return;
                            }

                            if (name.endsWith('next')) {

                                const aicars = this.getAiCars();

                                if(aicars.length>0) {

                                    if(world.cars[playid - 1] ){
                                        curEngine.removeCar(world.cars[playid - 1]);
                                    }

                                    this.playerCarIdx[playid-1]++;

                                    if(this.playerCarIdx[playid-1] >= aicars.length){
                                        this.playerCarIdx[playid-1] = 0;
                                    }
        
                                    const id = parseInt(aicars[this.playerCarIdx[playid-1]]);

                                    this.disabledPanelGroup('players', 'player'+playid, true);

                                    getCar(this.blockchaininfos, id, 0, this.blockchaininfos.SA.collectionName).then((aiDef)=>{

                                        const aiCar = new Car(world.carId++, aiDef); 
                                        aiCar.isAI = true;
                                        curEngine.addCar(aiCar, tmode, playid - 1).then(()=>{
                                            world.cars[playid - 1] = aiCar;
                                            world.computeCarPos();
                                            this.updatePlayersText();
                                            this.disabledPanelGroup('players', 'player'+playid, false);
                                        })
                                    })
                                }
                                return;
                            }

                            if (name.endsWith('start')) {

                                this.disabledPanelGroup('players', 'start', true);
                                this.startGame();
                                return;
                            }
                        }
                        
                    }

                    if ((selected === true) && (b.selected === false)) {

                        if ((!name.endsWith('-cont'))&&(!b.name.endsWith('-cont'))) {

                            if(panel === 'players'){

                                const playid = parseInt(group.substr(6 , 1));
                                const which = b.name.substr(7);
                                const tmode = this.renderMode === 0 ? this.servMode ===true ? 2 : 0 : this.renderMode === 1 ? 1 : 0;

                                if (name.startsWith('weather')) {
                                    const ar = name.split('-');
                                    const type = ar[1];
                                    this.gameData.envtype = type;
                                    this.enableWeather(this.gameData.envtype);
                                }else if (name.endsWith('AI')) {

                                    this.disabledPanelGroup('players', 'player'+playid, true);

                                    const aicars = this.getAiCars();

                                    this.setButtonState(b, 1);
                                    this.playerCarIdx[playid-1] = playid%2;
                                    const carid = aicars[this.playerCarIdx[playid-1]];

                                    getCar(this.blockchaininfos, carid, 0, this.blockchaininfos.SA.collectionName).then((aiDef)=>{
                                        const aiCar = new Car(world.carId++, aiDef); 
                                        aiCar.isAI = true;

                                        curEngine.addCar(aiCar, tmode, playid - 1).then( () => {
                                            world.cars.push(aiCar);
                                            world.computeCarPos();

                                            this.enablePlayerSelectEvent(playid, false);

                                            if(playid<4)
                                                this.enablePlayerSelectEvent(playid+1, false);

                                            this.updatePlayersText();

                                            this.disabledPanelGroup('players', 'player'+playid, false);
                                        })
                                    });
                                        
                                }else if (name.endsWith('None')) {

                                    for(let c =playid-1;c<world.cars.length;c++ ){
                                        curEngine.removeCar(world.cars[c]);
                                    }
                    
                                    while(world.cars.length > playid-1)
                                        world.cars.pop();
                    
                                    for(let c =playid+1;c<=4;c++ ){
                                        this.disablePlayerSelectEvent(c);
                                    }

                                    this.setButtonState(b, 1);

                                    const newc = this.findPanelButton(panel, name+ '-cont');
                                    if(newc){
                                        this.setButtonState(newc, 1);
                                    }

                                    this.updatePlayersText();
                                     
                                }else if (name.endsWith('PvP')) {

                                    this.setButtonState(b, 1);
                                }
                            }
                        }

                        const newc = this.findPanelButton(panel, b.name+ '-cont');
                        if(newc){
                            this.setButtonState(newc, b.disabled ? 2 : 1);
                        }

                        this.setButtonState(b, b.disabled ? 2 : 1);
                    }


                    if ((selected === false) && (b.selected === true)) {
                        if (!b.name.endsWith('-cont')) {
                        } else {
                        }
                        this.setButtonState(b, b.disabled ? 2 : 0);
                    }

                    b.selected = selected;
                }
            }

            if (dg !== null)
                this.disabledPanelGroup(dg.p, dg.g, dg.s);
        }


        onPlayersPointerClick(e) {
            if (this.hover.HoverButton != null) {
                this.selectPanelButton(this.hover.HoverButton.panel, this.hover.HoverButton.name, this.hover.HoverButton.group);
            }
        }

        onPlayersPointerMove(e) {
            const curEngine = this.curEngine;

            e = e || window.event;
            let dist = null;

            let rect = e.target.getBoundingClientRect();

            const width = this.glDomRef.current.offsetWidth;
            const height = this.glDomRef.current.offsetHeight;

            pointer.x = ((e.clientX - rect.left) / width) * 2 - 1;
            pointer.y = - ((e.clientY - rect.top) / height) * 2 + 1;

            const intersectsPt = [];
            raycaster.setFromCamera(pointer, curEngine.camera);
            raycaster.intersectObject(curEngine.selectScene, true, intersectsPt);
            this.processPointer(intersectsPt, this.hover);
        }

        updatePlayersText(){

            const ctx = this.CarsCanvas.getContext('2d');
            ctx.fillStyle = '#224422';
            ctx.fillRect(0, 0, this.CarsCanvas.width,this.CarsCanvas.height);

            for(let n =0;n<this.world.cars.length;n++){
                const car = this.world.cars[n];
                ctx.fillStyle = '#FFFFFF';
                ctx.strokeStyle = '#000000';
                ctx.globalAlpha = 1.0;
                ctx.font = "48px Arial";
                ctx.textAlign = 'center';
                ctx.fillText(car.carDef.name, 128, 48 + n * 64, 256);
               
                this.playerScreens[n].needsUpdate = true;
                this.playerScreens[n].map.needsUpdate = true;
                
            }
            this.CarsCanvasTex.needsUpdate = true;
        }

        
        async enableWeather(type){

            const curEngine = this.curEngine;
            const world = this.world;
          
            if(type === 'rain'){

                await curEngine.createRain(2000, world.track.roadObj ? [world.track.roadObj] : [world.track.ground], world.myCar.ChassisMesh.position);

                curEngine.addRain();
                curEngine.addFog(world.track.fogIntensity * 2);

            } else {
                curEngine.removeRain();
                //curEngine.addFog(0.015);
                curEngine.addFog(world.track.fogIntensity);
            }
        }

        async startGameSelection(){
            
            const self = this;



            await this.loadAICars();
            const curEngine = this.curEngine;
            const gltf = await curEngine.loadGLTF("players");
            if (!gltf)
                return;
            
            this.board = curEngine.deGroupGLB(gltf , false);
            this.buttons = [];

            this.CarsCanvas = document.createElement('canvas');
            this.CarsCanvas.width = 256;
            this.CarsCanvas.height = 256;
            this.playerScreens=[];

            this.CarsCanvasTex = curEngine.createTextureCanvas(this.CarsCanvas, false);

            this.board.name = "playerboard";

            this.board.traverse(function(child) {
                
                if(!child.isMesh)
                    return;

                if(!(child.material.length >0)){
                    console.log('startGameSelection : panel no mat '+child.name);

                    /*
                    child.material.polygonOffset= true;
                    child.material.polygonOffsetFactor= -20000.0;
                    child.material.polygonOffsetUnits = 0.1;
                    */

                    return;
                }

                for (let m of child.material)  {
                    /*
                    m.polygonOffset= true;
                    m.polygonOffsetFactor= -64000.0;
                    m.polygonOffsetUnits = 10;
                    m.depthWrite = true;
                    m.depthTest = true;
                    m.transparent = false;
                    */
                }


                if (child.name.startsWith('panel-')) {
                    const arr = child.name.split('-');
                    const panel = arr[1];

                    for (let m of child.material)  {

                      

                        if (panel === 'players') {
                            const unselable = m.name.endsWith('-cont') ? true : false;

                            if(m.name.startsWith('screen-')){

                                const ar = m.name.split('-');
                                const player = ar[1];
                                const playerid = parseInt(player.substr(6));
                                const matCol = m.color.clone();
                                m.color.setRGB(1,1,1);
                                m.map = self.CarsCanvasTex;

                                self.playerScreens[playerid-1] = m;
                            }

                            if(m.name.startsWith('start')){
                                curEngine.addSelectable(child, m);
                                self.buttons.push({ obj: child, panel: 'players', name: m.name, group: "start", selected: false, unselable: unselable });
                            }

                            if((m.name.startsWith('weather'))&&(!m.name.endsWith('txt'))){
                                const type = m.name.substr(7);
                                curEngine.addSelectable(child, m);
                                self.buttons.push({ obj: child, panel: 'players', name: m.name, group: "weather", selected: false, unselable: unselable });
                            }
                            
                            if((m.name.startsWith('racetype'))&&(!m.name.endsWith('txt'))){
                                const type = m.name.substr(7);
                                curEngine.addSelectable(child, m);
                                self.buttons.push({ obj: child, panel: 'players', name: m.name, group: "racetype", selected: false, unselable: unselable });
                            }

                            if((m.name.startsWith('player'))&&(!m.name.endsWith('txt'))){
                                const playerID = parseInt(m.name.substr(6, 1));
                                const which  = m.name.substr(7);

                                if(which.length > 0){
                                    curEngine.addSelectable(child, m);
                                    self.buttons.push({ obj: child, panel: 'players', name: m.name, group: "player"+playerID, selected: false, unselable: unselable });
                                }
                            }
                        }
                    }
                }
            });

            this.boardPos = {x: 0.0, y: 0.2, z: -1};
            this.board.meshGPU = curEngine.addCameraSpaceMesh(this.board, this.boardPos);

            if((this.world.myCar)&&(this.world.myCar.carDef.type == -2)) {
                this.gameData.racetype = 'practice';
                this.selectPanelButton ('players', 'racetype-practice', 'racetype');
                this.disabledPanelGroup('players', 'racetype', true);
            }

            this.enablePlayerSelectEvent(1, true);
            this.enablePlayerSelectEvent(2, false);
            this.enablePlayerSelectEvent(3, true);
            this.enablePlayerSelectEvent(4, true);

            
            this.enableWeather(this.gameData.envtype);

            let envname = 'sun';

            if(this.gameData.envtype === 'rain')
                envname = 'rain';
            else if(this.gameData.envtype === 'snow')
                envname = 'snow';

            this.selectPanelButton ('players', 'weather-'+envname, 'weather');


            this.updatePlayersText();

            this.mousePlayersMoveFunc = function(e) {self.onPlayersPointerMove(e)};
            this.mousePlayersPointerClick = function(e) {self.onPlayersPointerClick(e)};

            document.querySelector('#gl-dom').addEventListener('mousemove', this.mousePlayersMoveFunc);
            document.querySelector('#gl-dom').addEventListener('click', this.mousePlayersPointerClick);

            this.firstFrame = true;
        }

        
        initWebsocket(serverPath, sessh, amhost, gameid){

            //$('#loading-txt').html('connecting server ' + serverPath);
            this.setLoadingTxt('connecting server ' + serverPath);
            try{
                this.webSocket = new WebSocket(serverPath, ["protocolOne", "protocolTwo"]);
                this.webSocket.binaryType = "arraybuffer";

                console.log('websocket opened');
            }
            catch(e){
                //$('#loading-txt').html('unable to connect server ' + serverPath + ' ' + e.message);
                this.setLoadingTxt('unable to connect server ' + serverPath + ' ' + e.message);
                return;
            }

            const webSocket = this.webSocket;
            const curEngine = this.curEngine;
            const world = this.world;
            //const wallet = this.wallet;
            const self = this;

            webSocket.onerror = function (event) {  

                //$('#loading-txt').html('socket error on server ' + serverPath + ' ' + event);
                self.setLoadingTxt('socket error on server ' + serverPath + ' ' + event);

                self.gameStat = 2;
                self.gameMessage = 'server connection error';
                //self.wallet.UI.newAlert("server connection error");
                self.curEngine.stopEngine();
                webSocket.close();
            }

            webSocket.onopen = function (event) {

                //$('#loading-txt').html('connected game server');
                self.setLoadingTxt('connected game server');

                if(amhost)
                    webSocket.send('{"msg" : "startgame", "data":{ "id" : "' + sessh + '"}}');
                else
                    webSocket.send('{"msg" : "joingame", "data":{ "id" : "' + sessh + '", "gameid" : "' + gameid + '"}}');

                webSocket.onmessage = function (sockEv) {

                    if (typeof sockEv.data === 'string') {

                        let obj

                            try{
                                obj = JSON.parse(sockEv.data);
                            }
                            catch(e)
                            {
                                //$('#loading-txt').html('unable to parse message data ' + e.message);
                                self.setLoadingTxt('unable to parse message data ' + e.message);
                                //self.wallet.UI.newAlert('unable to parse message data ' + e.message);
                                return;
                            }
                            
                            if (obj.msg == "gameover") {
                                self.gameStat = 2;
                                self.gameMessage = obj.data;
                                self.endGameTime = new Date().getTime();
                                curEngine.stopEngine();
                            }else if (obj.msg == "finished") {
                                self.gameStat = 3;
                                self.gameMessage = obj.data;
                                self.endGameTime = new Date().getTime();
                                const tt = curEngine.clock.getElapsedTime();
                                const dt =  curEngine.clock.getDelta();
                                curEngine.updateCars(world, tt, dt);
                                curEngine.stopEngine();
                            }else if (obj.msg == "wait") {
                                //$('#loading ').html('waiting for player');
                                self.setLoadingTxt('waiting for player');
                            }else if (obj.msg == "error") {
                                self.setLoadingTxt  ("error : " + obj.data);
                            }else if (obj.msg == "queued") {
                                //$('#loading').html('server full, waiting for ' + obj.data + ' instance to finish');
                                self.setLoadingTxt('server full, waiting for ' + obj.data + ' instance to finish');
                            }else if (obj.msg == "ready") {
                                self.gameStat = 1;
                                //$('#loading').html('press any key to start');
                                self.setLoadingTxt('press any key to start');
                                curEngine.clock.getDelta();
                            }else if (obj.msg == "stats") {

                                this.setgameStats(obj.data);

                                //wallet.UI.setGameStats(obj.data, world.myCar.nLaps, parseFloat(world.myCar.multiplier).toFixed(1), world.track);
                                webSocket.close();
                            }else if(obj.msg === 'error'){
                                 self.setLoadingTxt('error connecting game server '+obj.data);
                            }

                    } else {

                            const delta = curEngine.clock.getDelta();
                            const now = curEngine.clock.getElapsedTime();

                            try{
                                const view = new DataView(sockEv.data);
                                self.fa = new Float32Array(view.buffer);
                                self.ia = new Uint32Array(view.buffer);
                            }
                            catch(e)
                            {
                                self.setLoadingTxt('unable to parse socket buffer ' + e.message);
                                return;
                            }

                            lastPing = now;

                            if (self.world.lastCarData === null) {
                                self.gameStat = 1;
                                world.initData(self.fa, self.ia, now);
                            }else{
                                self.animate(delta , now);
                            }
                                //world.bin2cars(self.fa, self.ia, now);
                    }
                }
            }
        }

        
        initGame(serverPath, sessh, amhost, gameid) {

            const curEngine = this.curEngine;
            const world = this.world;

            this.setLoadingTxt('compile shaders');  

            if(this.servMode){
                this.setLoadingTxt('starting game');
                this.initWebsocket(serverPath, sessh, amhost, gameid);
                return;
            }

            this.setLoadingTxt('init physics');  
         
            const self = this;
            let numAI = 0;
            world.computeCarPos();

            if(!this.isWorker){

                this.phys = new PhysicMain(Ammo);
                this.phys.createRoadPhy(world.track);

                if(world.track.groundGeo){

                    if(world.track.trackPoints.length < 2)
                        this.phys.createGroundMesh(world.track, world.track.terrain.offset);
                }

                this.phys.addPhyTrack(world.track);
                
                for(let n=0;n<world.cars.length;n++){
                    const car = world.cars[n];
                    const profile = car.isAI ? profiles[numAI++] : null;

                    if(world.track.carStartPos)
                        car.center.set(world.track.carStartPos.pos.x, world.track.carStartPos.pos.y, world.track.carStartPos.pos.z );

                    this.phys.addPhyCar(car, 0, 0, null, profile);
                }

                this.phys.updatePhysicsUniverse(world, frameTime, 0);
                this.fa = this.phys.getCars(this.world.track, 0, this.world.track.lapTime, this.player, 0);
                this.world.initData(this.fa, this.ia, this.world.startTime);

                this.gameStat = 1;
                this.setLoadingTxt('press any key to start');

            }else{
              
                this.worker.onmessage = async function (event) {

                    if(!self.started)
                        return;

                    if((self.gameStat == 2)||(self.gameStat == 3)){
                        self.setgameStats(event.data);
                        return;
                    }

                    if(self.gameStat === 1) {

                        world.lastBufferTime = self.clockRender.elapsedTime;

                        if((self.gameStat === 1)&&(self.physicBuffer === null)){
                            self.fa=new Float32Array(event.data);
                            self.ia=new Uint32Array(event.data);
                        }
                        
                        self.newFrame = true;
                        const dt = self.clockRender.getDelta();
                        const tt = self.clockRender.elapsedTime;
                        await self.animate(dt , tt);
                    }
                  
                    if((self.gameStat === 0)&&(!world.lastCarData)){
                        self.newFrame = true;
                        self.gameStat = 1;
                        world.startTime = self.clockRender.elapsedTime;

                        if(self.physicBuffer === null){
                            self.fa=new Float32Array(event.data);
                            self.ia=new Uint32Array(event.data);
                        }

                        world.initData(self.fa, self.ia, world.startTime);
                        self.setLoadingTxt('press any key to start');
                    }
                };

                if(world.track.groundGeo) {
                    const ggeo = world.track.groundGeo;
                    world.track.groundMesh = new Float32Array(ggeo.attributes.position.array.buffer);
                }

                const phycars = [];
                for(let n=0;n<world.cars.length;n++){
                    const car = world.cars[n].toPhys();
                    car.profile = car.isAI ? profiles[numAI++] : null;

                    if(world.track.carStartPos){
                        car.center.x=world.track.carStartPos.pos.x;
                        car.center.y=world.track.carStartPos.pos.y;
                        car.center.z=world.track.carStartPos.pos.z;
                    }
                    phycars.push(car);
                }

                const phytrack = world.track.toPhys();
                this.worker.postMessage({msg : 'addtrack', data: {track : phytrack, buffer: this.physicBuffer, cars: phycars}});
                this.setLoadingTxt('starting game');
            }
        }


        async start(){
            const curEngine = this.curEngine;
            const world = this.world;
            const self = this;

            if(this.physicBuffer){
                this.fa = new Float32Array(this.physicBuffer);
                this.ia = new Int32Array(this.physicBuffer);
            }

            this.setactiveLinks({selectCar: true, garage: true, restart : false, lobby : false});
            
            world.lastCarData = null;

            this.currentSelectedTarget = -1;
            this.currentSelectedTargetSubSystem = -1;
            this.currentTarget = {name:  null, subsystemname : null};

            this.curEngine.camera.near = 0.5;
            this.curEngine.camera.far = 500;
            this.curEngine.camera.updateProjectionMatrix();

            this.curEngine.addLoadingController(this.loadingController);
            curEngine.renderMainScene = false;

            //curEngine.setBumpSize(1024 * 8, 1024 * 8, 16);
            curEngine.camMode = 3;

            if(curEngine.isVr)
                this.setupVRCarEvents();

            this.curEngine.initVR(function(on) { self.enableVR(on) });

            this.firstTime = true;
            this.intro = 0;
            this.gameStat = 0;
            this.inited = false;
            this.started = false;

            if(this.animateTimer == null) {

                /*
                if(this.renderMode == 2)
                    this.brender();
                */
                
                if(this.renderMode == 0){
                    this.firstFrame = true;
                    curEngine.renderer.setAnimationLoop(async function(e){ await self.srender() } );
               }
                    

            }
                
            if(curEngine.useMobileUI)
                curEngine.addUIButtons(this.gameControls);

            curEngine.initControllers();

            
            
            //curEngine.addRaceUI(this.raceUI);

            if(this.world.track.name === 'water')
                curEngine.setBloomParams(0.4, 0.8, 0.6);
            else
                curEngine.setBloomParams(this.world.track.bloom.strength, this.world.track.bloom.radius, this.world.track.bloom.thresold);

            curEngine.numFrames = 0;
        
            this.servMode = this.gameData.racetype === 'practice' ? false : true;

            const tmode = this.renderMode === 0 ? this.servMode ===true ? 2 : 0 : 0;

            if(world.track) {

                world.track.terrain.mesh.traverse((child) =>{

                    if (child.type == 'Mesh') {

                        if (child.name.startsWith('fire-start')) {
                            const op = new THREE.Vector3(child.position.x + world.track.terrain.offset.x, child.position.y + world.track.terrain.offset.y, child.position.z + world.track.terrain.offset.z);
                            curEngine.addFire(op);
                        }

                        if (child.name.startsWith('cyberpart')) {
                            const op = new THREE.Vector3(child.position.x + world.track.terrain.offset.x, child.position.y + world.track.terrain.offset.y, child.position.z + world.track.terrain.offset.z);
                            curEngine.addCyber(op);
                        }

                        if (child.name.startsWith('sandpart')) {
                            const op = new THREE.Vector3(child.position.x + world.track.terrain.offset.x, child.position.y + world.track.terrain.offset.y, child.position.z + world.track.terrain.offset.z);
                            curEngine.addSand(op);
                        }

                        if (child.name.startsWith('firework')) {
                            const op = new THREE.Vector3(child.position.x + world.track.terrain.offset.x, child.position.y + world.track.terrain.offset.y, child.position.z + world.track.terrain.offset.z);
                            curEngine.addFirework(op);
                        }
                    }
                });
            }

            const track = world.track;
            const carQuat = track.trackPoints[track.startPts].rot.clone();
            const el = new THREE.Euler(0, 3.14 / 2, 0, "XYZ");
            const q = new THREE.Quaternion();
            q.setFromEuler(el);
            carQuat.multiply(q);
            
             
            if(this.gameData.np == 1) {
                 this.setLoadingTxt('load car');

              
                const carDef = await getCar(this.blockchaininfos, this.gameData.carid, this.gameData.cartype);
                world.myCar = new Car(world.carId++, carDef); 
        
                await curEngine.addCar(world.myCar, tmode, world.cars.length);
                world.cars.push(world.myCar);
            }else{
                 this.setLoadingTxt('load host car');

                const carDef = await getCar(this.blockchaininfos, this.gameData.carid, this.gameData.cartype, this.gameData.account);
                const car1 = new Car(world.carId++, carDef); 
        
                await curEngine.addCar(car1, tmode, world.cars.length);
                world.cars.push(car1);

                
                this.setLoadingTxt('waiting for player');
                const wpres = await fetch('/api/waitPlayer');
                const jsresult = await wpres.json();
                
                if(jsresult.error){
                    this.setLoadingTxt('error getting player info ');
                }else{
                    const player= jsresult.result;
                    this.setLoadingTxt('load player car');
                    const carDef2 = await getCar(this.blockchaininfos, player.player_carid, player.player_cartype, player.player_account);
                    const car2 = new Car(world.carId++, carDef2);
                    await curEngine.addCar(car2, tmode, world.cars.length);
                    world.cars.push(car2);
                    
                    if(this.gameData.amhost)
                        world.myCar = car1;
                    else
                        world.myCar = car2;
                }
            }
            world.computeCarPos();

            this.setLoadingTxt('initialize race');

            this.curEngine.updateEnergyUIStats(this.energyUI, world.myCar.carDef);
            this.curEngine.addEngineUI(this.engineUI);
            this.curEngine.addEnergyUI(this.energyUI);
            
            this.curEngine.addNitroUI(this.nitroUI);
            this.curEngine.addInfosUI(this.infosUI);
            
            this.dir1 = {};
            this.dir2 = {};

            //if(world.track.trackPoints.length<2)
            {
                this.curEngine.addDirLight(this.dir1, new THREE.Vector3(1, 4, 8.0), new THREE.Vector3(0.5, 0.6, 0.7) )
                this.curEngine.addDirLight(this.dir2, new THREE.Vector3(-8, 4, -1.0), new THREE.Vector3(0.2, 0.3, 0.2) )
            }

            if(world.track.trackPoints.length > 1)
                await this.startGameSelection();
            else{
                 this.enableWeather(this.gameData.envtype);
                 await this.startGame();
            }

            world.myCar.pathFinder = new PathFinder(world.track.navmeshs.length);

            if(this.renderMode == 2)
                curEngine.setSunLight(new THREE.Vector3(0, 0, 0), world.myCar.ChassisMesh);
            else{
                curEngine.setSunLight(new THREE.Vector3(0, 0, 0), world.myCar.ChassisMesh);
            }
    
            this.removeLoadingTxt();
            this.curEngine.removeLoading(this.loadingController);
            curEngine.renderMainScene = true;

            this.setactiveLinks({selectCar: true, garage: true, restart : true, lobby : true});

        }
    }

    